import React, { useEffect, useState, useRef } from "react";
// import { Modal } from "bootstrap";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { compareAsc, format, addMonths } from "date-fns";
import moment from "moment";
import Skills from "./Skills/Skills";
import DatePicker from "react-datepicker";
import {
  getSkillByDeptID,
  httpCreateSubSkill,
} from "../HR/Skills/subSkills/api/calls";
import { httpCreateUserGroup } from "../Employee/Skills/api/calls";

import Select from "react-select";
import { data } from "jquery";
let reporting_option = [];
let finalreport_option = [];

function EditEmployeeCom(props) {
  const empshiftRef = useRef();
  const salutationRef = useRef();
  const fnameRef = useRef();
  const timezoneRef = useRef();
  const companyRef = useRef();
  const divisionRef = useRef();
  const empcategoryRef = useRef();
  const systemRoleRef = useRef();
  const roleRef = useRef();
  const sub_roleRef = useRef();
  const dateofjoiningRef = useRef();
  const dateofbirthRef = useRef();
  const lastworkingdayRef = useRef();
  const newworklocationRef = useRef();
  const designationjRef = useRef();
  const skillRef = useRef();

  const appointmentLetterRef = useRef(null);
  const relavingLetterRef = useRef(null);

  let navigate = useNavigate();

  // const modalRef = useRef();
  // useEffect(() => {
  //   modalRef.current = new Modal(
  //     document.getElementById("previouscompanydetail")
  //   );
  // }, []);

  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem("key"));

  const [skillData, setUserSkillData] = useState([]);

  const [salutation, setSalutation] = useState("");
  const [fname, setFname] = useState("");
  const [mname, setMname] = useState("");
  const [lname, setLname] = useState("");
  const [gargen, setGargen] = useState("");
  const [gender, setGender] = useState("");
  const [dateofbirth, setDateofbirth] = useState("");
  const [lastWorkingday, setLastWorkingday] = useState("");
  const [marriage, setMarriage] = useState("");
  const [bloodgroup, setBloodgroup] = useState("");
  const [nationality, setNationality] = useState("");
  const [adhaarname, setAdhaarname] = useState("");
  const [adhaarnumber, setAdhaarnumber] = useState("");
  //   cpnst[passport,setPassport] = useState('');
  const [pancardnumber, setPancardnumber] = useState("");

  const [company, setCompany] = useState("");
  const [empstatus, setEmpstatus] = useState("");
  const [empcode, setEmpcode] = useState("");

  const [division, setDivision] = useState("");
  const [department, setDepartment] = useState("");
  const [designation, setDesignation] = useState("");
  const [empcategory, setEmpcategory] = useState("");
  const [noticeperiod, setNoticeperiod] = useState("");

  const [dateofjoining, setDateofjoining] = useState("");
  const [probation_period, setProbation_period] = useState("");
  const [confirmationdate, setConfirmationdate] = useState("");

  const [ctc, setCtc] = useState("");
  const [mhr, setMhr] = useState("");
  const [salaryType, setSalaryType] = useState("");
  const [bankname, setBankname] = useState("");
  const [accountnumber, setAccountnumber] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [pfapplicable, setPfapplicable] = useState("");
  const [pfnumber, setPfnumber] = useState("");
  const [pfgroup, setPfgroup] = useState("");
  const [emp_id, setEmp_id] = useState("");

  const [color, setColor] = useState("");
  const [errmsg, setErrmsg] = useState("");
  const [buttonstatus, setbuttonstatus] = useState(true);
  const [uan_number, setUan_number] = useState("");
  // const [pt_applicable, setPt_applicable] = useState('');
  const [timezone, setTimezone] = useState("");
  const [systemRole, setSystemRole] = useState("");
  const [role, setRole] = useState("");
  const [sub_role, setSub_Role] = useState("");
  const [depdata, setDepdata] = useState([]);
  const [dept, setDept] = useState([]);

  const [roledata, setRoledata] = useState([]);
  const [comdata, setComdata] = useState([]);
  const [system_role, setSystem_role] = useState([]);
  const [persona_email, setPersonal_email] = useState("");
  const [alt_email, setAlt_email] = useState("");
  const [contact_number, setContact_number] = useState("");
  const [errMsgShift, setErrMsgShift] = useState("");
  const [err, setErr] = useState("");
  // const [officialemailstatus, setOfficialemailstatus] = useState(true);

  const [countrycode, setCountrycode] = useState("");
  const [reportingmanager, setreportingmanager] = useState("");
  const [finalReport, setFinalReport] = useState("");
  const [shift, setShift] = useState("");
  const [shiftList, setShiftList] = useState([]);
  const [complist, setComplist] = useState([]);
  const [workplace, setWorkplace] = useState("");
  const [searchParams, setSearchParams] = useSearchParams("");
  const id = searchParams.get("id");
  const [subRole, setSubRole] = useState([]);
  const [srole, setSrole] = useState("");

  const [CountryINWish, setIsHiddenIndia] = useState("");

  const [errsalutaion, setErrsalutaion] = useState("");
  const [errFname, setErrFname] = useState("");
  const [errtimeZone, setErrtimeZone] = useState("");
  const [errcompany, setErrcompany] = useState("");
  const [errdivision, setErrdivision] = useState("");
  const [errempcategory, setErrempcategory] = useState("");
  const [errsystemRole, setErrsystemRole] = useState("");
  const [errsub_role, setErrsub_role] = useState("");
  const [errdateofjoining, setErrdateofjoining] = useState("");
  const [errlastworkingday, setErrlastworkingday] = useState("");
  const [errshift, setErrshift] = useState("");
  const [errdateofbirth, setErrdateofbirth] = useState("");
  const [newworklocation, setNewworklocation] = useState("");

  const [text, setText] = useState("");

  const [hobbies, setHobbies] = useState("");
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");

  const [emercontactpersion, setEmercontactpersion] = useState("");
  const [emercontactnumber, setEmercontactnumber] = useState("");
  const [emercontactrelation, setEmercontactrelation] = useState("");
  const [currenAdd, setcurrenAdd] = useState("");
  const [permanentaddress, setPermanentaddress] = useState("");
  const [dateofwedding, setDateofwedding] = useState("");
  const [computerSkills, setComputerSkills] = useState("");
  const [otherSkills, setOtherSkills] = useState("");

  const [speak1, setSpeak1] = useState("");
  const [speak2, setSpeak2] = useState("");
  const [write1, setWrite1] = useState("");
  const [write2, setWrite2] = useState("");
  const [read1, setRead1] = useState("");
  const [read2, setRead2] = useState("");
  const [understand1, setUnderstand1] = useState("");
  const [understand2, setUnderstand2] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [response, setResponse] = useState(null);
  const [deptIds, setDeptIds] = useState("");
  useEffect(() => {
    getCompanyList();
    getuserById();

    previouscompempdetails();

    getDepartmentList();
    getSystemRole();
    getLocation();
    getReportingManager();
    // getWorkLocation()
    getCountryList();
  }, []);

  const [reportimgManageList, setReportimgManageList] = useState([]);
  const getReportingManager = () => {
    const response = fetch(SERVER_URL + `api/common/manager_list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        // setReportimgManageList(data.result)
        reporting_option = [];
        finalreport_option = [];
        data?.result.map((row) => {
          reporting_option.push({
            value: row.id,
            label: row.name + " (" + row.user_code + ")",
          });
          finalreport_option.push({
            value: row.id,
            label: row.name + " (" + row.user_code + ")",
          });
        });
      });
  };
  const getSystemRole = () => {
    const response = fetch(SERVER_URL + `api/common/sytem-role`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSystem_role(data.result);
      });
  };

  const getCompanyList = () => {
    const response = fetch(SERVER_URL + `api/common/company_list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setComdata(data.result);
      });
  };

  const getDepartmentList = (deptid) => {
    const response = fetch(SERVER_URL + `api/common/department_list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const options = data?.result?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setDept(options);
        setDepdata(data?.result);
      });
  };

  function handleChange(deptid) {
    setRole(deptid);
    setDepartment(deptid);
    if (deptid == "" || deptid == null || deptid == undefined) {
      return false;
    } else {
      getSkillByDeptID(deptid).then((res) => {
        if (res.status) {
          setRoledata(res.data);
        }
      });
    }
  }

  const previouscompempdetails = () => {
    const response = fetch(SERVER_URL + `api/employee/empprecompanydetails`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        id: id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setEmpExp(data.data);
        setPreviousCompanymodal(false);
      });
  };

  const getuserById = async () => {
    const response = await fetch(SERVER_URL + `api/employee/edit`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        id: id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.status == true) {
          const response = data?.data;
          console.log("API COMPLETE RESPONSE:", data);
          console.log("API DATA:", data?.data);
          console.log("department_ids:", data?.data?.department_ids);
          setResponse(response);
          // console.log("response :", response);
          setRead1(response.language1_ReadP);
          setRead2(response.language2_ReadP);
          setSpeak1(response.language1_SpeakP);
          setSpeak2(response.language2_SpeakP);
          setWrite1(response.language1_WriteP);
          setWrite2(response.language2_WriteP);
          setUnderstand1(response.understand1);
          setUnderstand2(response.understand2);

          setUploadpassport(response.Passportno);
          setUploadaddressproof(response.AddressProof);
          setUploadphotgraph(response.PassportSizePhoto);
          setUploadpancard(response.Filepancard);
          setUploadaadharcard(response.AadharcardFiles);

          setCountry(response.country);
          setState(response.state);
          setSalutation(response.salutation);
          setFname(response.fname);
          setMname(response.mname);
          setLname(response.lname);
          setGargen(response.guardian_name);
          setGender(response.gender);
          setContact_number(response.contact_no);
          setPersonal_email(response.personal_email);
          setAlt_email(response.alt_email);
          // setOfficialemailstatus(response.official_email_status)
          setDateofbirth(moment(response.birthday).format("yyyy-MM-DD"));
          setMarriage(response.marrige_status);
          setBloodgroup(response.blood_group);
          setNationality(response.nationality_type);
          setAdhaarname(response.uid_name);
          setAdhaarnumber(response?.uid_no ? response?.uid_no : "");
          setPancardnumber(response.pan_no);
          setCountrycode(response.country_code);
          setCompany(response.comp_id);
          setDivision(response.division);
          setreportingmanager(response.reporting_manager);
          setFinalReport(response.final_reporting_mng);
          setWorkplace(response.workplace);
          setRole(response.role);
          setSub_Role(response.sub_role);
          setEmpcode(response.user_code);
          setEmpstatus(response.status);
          setLastWorkingday(response.lastWorkingday);
          setDateofjoining(moment(response.joining_date).format("yyyy-MM-DD"));
          setDateofwedding(moment(response.wedding_day).format("yyyy-MM-DD"));
          setProbation_period(response.probation_period);

          setHobbies(response.hobbies);
          setNationality(response.nationality_type);
          setHeight(response.Height);
          setWeight(response.Weight);
          setEmercontactrelation(response.personrelation);
          setEmercontactnumber(response.emergencyphonenumber);
          setEmercontactpersion(response.emergencycontactperson);

          setPermanentaddress(response.permanent_add);
          setcurrenAdd(response.address);
          if (response?.department_ids) {
            setDeptIds(String(response.department_ids));
          }

          // setConfirmationdate(response.hr_confirmationdate)
          setConfirmationdate(
            response.hr_confirmationdate
              ? moment(response.hr_confirmationdate).format("yyyy-MM-DD")
              : "",
          );
          // setRole(response.system_role)

          if (response?.role != "") {
            handleChange(response?.role);
          }
          // if(response?.sub_role!='' || response?.sub_role!=null || response?.sub_role!=undefined){
          //     alert(sub_role)
          //     getSkills_list(sub_role)
          // }
          setSkill(response.skill);
          setDesignation(response.role_id);
          setEmpcategory(response.user_type);
          setNoticeperiod(response.noticeperiod);

          setSalaryType(response.salary_type);
          setCtc(response.ctc);
          setMhr(response.actual_mhr);
          setBankname(response.bank_name);
          setAccountnumber(response.account_no);
          setIfsc(response.bank_ifsc);
          setPfapplicable(response.pf_applicable);
          setPfnumber(response.pf_no);
          setPfgroup(response.pf_group);
          setEmp_id(response.id);
          setUan_number(response.uan_number);
          // setPt_applicable(response.pt_applicable)
          setSystemRole(response.system_role_id);
          setTimezone(response.time_zone);
          setShift(response.shift);
          setText(response.comment);
          setComputerSkills(response.computer_skills);
          setOtherSkills(response.other_skills);
          //  alert(response.time_zone)

          if (response.time_zone == 5) {
            setIsHiddenIndia(1);
            setTimezone(response.time_zone);
            // setNationality("India");
          } else if (
            response.time_zone == 1 ||
            response.time_zone == 3 ||
            response.time_zone == 4 ||
            response.time_zone == 6 ||
            response.time_zone == 7 ||
            response.time_zone == 8
          ) {
            setIsHiddenIndia(2);
            setTimezone(response.time_zone);
            // setNationality("United States of America");
          } else if (response.time_zone == 2) {
            setIsHiddenIndia(2);
            setTimezone(response.time_zone);
            // setNationality("United Kingdom");
          } else {
            setTimezone("");
            setIsHiddenIndia("");
            // setNationality("");
          }
        } else {
          setErrmsg("Error! Something went wrong");
          setbuttonstatus(false);
        }
      });
  };
  // useEffect(() => {
  //   if (response?.department_ids && dept.length) {
  //     const ids = response.department_ids
  //       .split(",")
  //       .filter(Boolean)
  //       .map(Number);

  //     const selected = dept.filter((d) => ids.includes(d.value));

  //     setSelectedOptions(selected);
  //     setDeptIds(ids.join(","));
  //   }
  // }, [response, dept]);
  useEffect(() => {
    if (!response?.department_ids || !dept?.length) {
      return;
    }

    const ids = String(response.department_ids)
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);

    console.log("Department IDs:", ids);
    console.log("Department options:", dept);

    const selected = dept.filter((item) => ids.includes(String(item.value)));

    console.log("Selected departments:", selected);

    setSelectedOptions(selected);
    setDeptIds(ids.join(","));
  }, [response, dept]);
  useEffect(() => {
    getSkills_list(sub_role);
  }, [sub_role]);
  const [errSkill, setErrSkill] = useState("");
  const handleEdituser = () => {
    const user_login_id = localStorage.getItem("userId");
    const date = new Date();
    const date_formate = format(date, "yyyy-MM-dd HH:m:SS");

    setErrsalutaion("");
    setErrFname("");
    setErrtimeZone("");
    setErrcompany("");
    setErrdivision("");
    setErrempcategory("");
    setErrsystemRole("");
    setErrrole("");
    setErrsub_role("");
    setErrdateofjoining("");
    setErrshift("");
    setErrdateofbirth("");
    setErrSkill("");
    setErrlastworkingday("");
    if (company == "" || company == null || company == undefined) {
      setErrcompany("red");
      companyRef.current.focus();
      return false;
    } else if (
      role == "" ||
      role == null ||
      roleRef.current == "" ||
      roleRef.current == null
    ) {
      setErrrole("red");
      roleRef.current.focus();
      return false;
    } else if (
      sub_role == "" ||
      sub_role == null ||
      sub_roleRef.current == "" ||
      sub_roleRef.current == null
    ) {
      setErrsub_role("red");
      setSub_dept_status("block");
      sub_roleRef?.current?.focus();
      return false;
    } else if (
      skill == "" ||
      skill == null ||
      skill == undefined ||
      skillRef.current == "" ||
      skillRef.current == null
    ) {
      setErrSkill("red");
      setSkill_status("block");
      skillRef?.current?.focus();
      return false;
    } else if (
      empcategory == "" ||
      empcategory == null ||
      empcategory == undefined
    ) {
      setErrempcategory("red");
      empcategoryRef.current.focus();
      return false;
    } else if (
      systemRole == "" ||
      systemRole == null ||
      systemRole == undefined
    ) {
      setErrsystemRole("red");
      systemRoleRef.current.focus();
      return false;
    }

    if (salutation == "" || salutation == null) {
      setErrsalutaion("red");
      salutationRef.current.focus();
      return false;
    } else if (fname == "" || fname == null) {
      setErrFname("red");
      fnameRef.current.focus();
      return false;
    } else if (timezone == "" || timezone == null) {
      setErrtimeZone("Red");
      timezoneRef.current.focus();
      return false;
    } else if (shift == "" || shift == null || shift == undefined) {
      setErrshift("red");
      empshiftRef.current.focus();
      return false;
    } else if (dateofjoining == "" || dateofjoining == null) {
      setErrdateofjoining("red");
      dateofjoiningRef.current.focus();
      return false;
    } else if (
      country == 1 &&
      (dateofbirth == "" || dateofbirth == null || dateofbirth == undefined)
    ) {
      setErrdateofbirth("red");
      dateofbirthRef.current.focus();
      return false;
    } else if (
      empstatus == 2 &&
      (lastWorkingday == "" ||
        lastWorkingday == null ||
        lastWorkingday == undefined)
    ) {
      setErrlastworkingday("red");
      lastworkingdayRef.current.focus();
      return false;
    } else {
      // alert(lastWorkingday)

      //       return false
      const response = fetch(SERVER_URL + `api/employee/update`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
        body: JSON.stringify({
          id: emp_id,
          country: country,
          state: state,
          emailpersonal: persona_email,
          alrtemail: alt_email ? alt_email : "",
          salutation: salutation,
          fname: fname,
          mname: mname,
          lname: lname,
          mhr: mhr,
          gurgaon: gargen,
          gender: gender,
          timezone: timezone,
          workplace: workplace,
          dateofbirth: dateofbirth,
          marriage_status: marriage,
          marriage_date: dateofwedding,
          bloodgroup: bloodgroup,
          height: height,
          weight: weight,
          hobbies: hobbies,
          nationality: nationality,
          skill: skill,
          country_code: countrycode,
          adhaarnumber: adhaarnumber,
          pancardnumber: pancardnumber,
          comp: company,
          division: division,
          // deptIds:deptIds.replace(/,+$/, ""),
          deptIds: (deptIds || "").replace(/,+$/, ""),
          contact: contact_number,
          //dept: department,
          reporting_manager: reportingmanager,
          finalreporting: finalReport,
          empcode: empcode,
          status: empstatus,
          joiningdate: dateofjoining,
          probation_period: probation_period,
          confirmationdate: confirmationdate,
          role: role,
          sub_role: sub_role,
          usertype: empcategory,
          noticeperiod: noticeperiod,
          salaryType: salaryType,
          ctc: ctc,
          bankname: bankname,
          accountnumber: accountnumber,
          ifsc: ifsc,
          pfapplicable: pfapplicable,
          pfnumber: pfnumber,
          pfgroup: pfgroup,
          // pt_applicable: pt_applicable,
          uan_number: uan_number,
          systemRole: systemRole,
          updated_on: date_formate,
          updated_by: user_login_id,
          shift: shift,
          lastdya: lastWorkingday,
          text: text,
          emercontactpersion: emercontactpersion,
          emercontactrelation: emercontactrelation,
          emercontactnumber: emercontactnumber,
          currenAdd: currenAdd,
          permanentaddress: permanentaddress,
          computerSkills: computerSkills,
          otherSkills: otherSkills,
          speak1: speak1,
          speak2: speak2,
          read1: read1,
          read2: read2,
          write1: write1,
          write2: write2,
          understand1: understand1,
          understand2: understand2,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === true) {
            setErrmsg("Employee, Successfully updated");
            setColor("green");
            addUserSkill(emp_id);
            setTimeout(function () {
              navigate("/employeelist");
            }, 1000);
          } else {
            setErrmsg("Error! Something went wrong");
            setbuttonstatus(false);
            setColor("red");
          }
        });
    }
  };
  const addUserSkill = (id) => {
    if (skillData) {
      const userSkill = {
        user_id: id,
        skillData,
      };
      httpCreateUserGroup(userSkill);
    }
  };
  const userSkillParentCallback = (userSkillChildData) => {
    setUserSkillData(userSkillChildData);
  };
  const [locationlist, setLocationlist] = useState([]);
  const getLocation = async (id) => {
    const response = await fetch(
      SERVER_URL + `api/common/time-zone-list?countryId=${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setLocationlist(data.result);
        }
      });
  };
  useEffect(() => {
    getShiftList();
  }, []);
  const getShiftList = () => {
    const response = fetch(SERVER_URL + `api/common/getshiftlist`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        emailpersonal: persona_email,
        city: "",
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setShiftList(data.result);
      });
  };
  const [workLocationlist, setWorkLocationlist] = useState([]);
  const getWorkLocation = async (state) => {
    const response = await fetch(
      SERVER_URL + `api/common/getworkLocation?stateid=${state}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setWorkLocationlist(data.result);
        }
      });
  };
  const handleDepartment = (val) => {
    handleChange(val);
    setSub_Role("");
    setSkillList([]);
    getSkillByDeptID(val).then((res) => {
      if (res.status) {
        setSubRole(res.data);
      }
    });
  };
  // function getSubroleBydeptId(id) {
  //     if (id == '') {
  //         return false
  //     } else {
  //         const response = fetch(SERVER_URL + `api/common/get_department_role`,
  //             {
  //                 method: 'PUT',
  //                 headers: {
  //                     'Accept': 'application/json',
  //                     'Content-Type': 'application/json',
  //                     'authorization': `bearer ${token.value}`
  //                 },
  //                 body: JSON.stringify({
  //                     id: id
  //                 })
  //             }).then(res => res.json())
  //             .then(data => {
  //                 if (data.status == true) {
  //                     setSubRole(data.result)
  //                     sub_role()

  //                 }
  //             })
  //     }

  // }
  const [sub_dept_status, setSub_dept_status] = useState("block");
  const handleAddSubRole = () => {
    setSub_dept_status(sub_dept_status == "block" ? "none" : "block");
  };
  const handleAddSkill = () => {
    setSkill_status(skill_status == "block" ? "none" : "block");
  };
  const [errrole, setErrrole] = useState("");
  const [errsubrole, setErrsubrole] = useState("");
  const [newSubrole, setNewSubrole] = useState("");
  const handleSaveSubRole = () => {
    setErrrole("");
    setErrsubrole("");
    if (role == "") {
      setErrrole("red");
      return false;
    }
    if (newSubrole == "") {
      setErrsubrole("red");
      return false;
    } else {
      check_department(department, newSubrole);
    }
  };
  const [errcheckrole, setErrcheckrole] = useState("");
  const check_department = (department, newSubrole) => {
    setErrcheckrole("");
    setErrsubrole("");
    const response = fetch(SERVER_URL + `api/common/checkdepartment`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        role: department,
        name: newSubrole,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          if (data?.result.total > 0) {
            setErrcheckrole("Already exists");
            setErrsubrole("red");

            return false;
          } else {
            add_new_sub_role(department, newSubrole);
          }
        }
      });
  };
  const add_new_sub_role = () => {
    const user_login_id = localStorage.getItem("userId");
    const date = new Date();
    const date_formate = format(date, "yyyy-MM-dd HH:m:SS");
    const response = fetch(SERVER_URL + `api/common/add_department`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        role: role,
        name: newSubrole,
        created_on: date_formate,
        created_by: user_login_id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          //handleChange(role)
          setSub_dept_status("block");
          setSub_Role("");
          setNewSubrole("");

          setNewSubrole("");
          getSkillByDeptID(department).then((res) => {
            if (res.status) {
              setRoledata(res.data);
            }
          });
        }
      });
  };
  const handleCancelSubRole = () => {
    setSub_dept_status(sub_dept_status == "none" ? "block" : "none");
    setNewSubrole("");
  };

  const [location_status, setLocation_status] = useState("block");
  const handleWorkLocation = () => {
    setLocation_status(location_status == "none" ? "block" : "none");
  };
  const handleCancellocation = () => {
    setLocation_status(location_status == "none" ? "block" : "none");
    setNewworklocation("");
  };
  const [errwrklsn, setErrwrklsn] = useState("");
  const handleSaveLocation = () => {
    setErrwrklsn("");
    setErrstate("");
    const user_login_id = localStorage.getItem("userId");
    const date = new Date();
    const date_formate = format(date, "yyyy-MM-dd HH:m:SS");

    if (state == "" || state == null || state == undefined) {
      setErrstate("red");
      return false;
    }

    if (newworklocation == "" || newworklocation == null) {
      setErrwrklsn("red");
      newworklocationRef.current.focus();
      return false;
    } else {
      const response = fetch(SERVER_URL + `api/common/add_workLocation`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
        body: JSON.stringify({
          state: state,
          location: newworklocation,
          created_on: date_formate,
          created_by: user_login_id,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status == true) {
            setNewworklocation("");
            setLocation_status("block");
            setWorkplace("");
            getWorkLocation(state);
          }
        });
    }
  };

  const handelIsHiddenCountryWish = (e) => {
    setDateofbirth("");
    const TimeZoneID = e.target.value;
    if (TimeZoneID == 5) {
      setIsHiddenIndia(1);
      setTimezone(TimeZoneID);
      setNationality("India");
    } else if (
      TimeZoneID == 1 ||
      TimeZoneID == 3 ||
      TimeZoneID == 4 ||
      TimeZoneID == 6 ||
      TimeZoneID == 7 ||
      TimeZoneID == 8
    ) {
      setIsHiddenIndia(2);
      setTimezone(TimeZoneID);
      // setNationality("United States of America");
    } else if (TimeZoneID == 2) {
      setIsHiddenIndia(2);
      setTimezone(TimeZoneID);
      // setNationality("United Kingdom");
    } else {
      setTimezone("");
      setIsHiddenIndia("");
      // setNationality("");
    }
  };

  const handleChangeNumber = (e) => {
    if (!isNaN(Number(e.target.value))) {
      setContact_number(e.target.value);
    }
  };

  const [skill_status, setSkill_status] = useState("block");
  const [skill, setSkill] = useState("");
  const [skillList, setSkillList] = useState([]);

  const getSkills_list = (id) => {
    if (id == "" || id == null || id == undefined) return false;
    const response = fetch(SERVER_URL + `api/common/getSkillsList?id=${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setSkillList(data.data);
        }
      });
  };
  const [errskill, setErrskill] = useState("");
  const [newSkill, setNewSkill] = useState("");
  const handleCancelSkill = () => {
    setSkill_status(skill_status == "block" ? "none" : "block");
    setNewSkill("");
  };
  // const [errdesignation, setErrdesignation] = useState('');
  const handleSaveSkill = () => {
    setErrskill("");
    setErrsub_role("");
    if (sub_role == "" || sub_role == null || sub_role == undefined) {
      setErrsub_role("red");
      sub_roleRef.current.focus();
      return false;
    } else if (newSkill == "" || newSkill == null || newSkill == undefined) {
      setErrskill("red");
      return false;
    } else {
      check_skill(sub_role, newSkill);
    }
  };
  const [errcheckskill, setErrcheckskill] = useState("");
  const check_skill = (designation, newSkill) => {
    setErrskill("");
    setErrcheckskill("");
    const response = fetch(SERVER_URL + `api/common/checkskill`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        id: designation,
        name: newSkill,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          if (data?.result.total > 0) {
            setErrskill("red");
            setErrcheckskill("Already Exist");
          } else {
            httpCreateSubSkill({ name: newSkill, group_id: sub_role }).then(
              (res) => {
                if (res.status) {
                  getSkills_list(sub_role);
                  setSkill_status("block");
                  setSkill("");
                }
              },
            );
          }
        }
      });
  };
  const [country, setCountry] = useState("");
  const handleCountry = (id) => {
    if (id === null || id === "" || id === undefined) return;
    getLocation(id);
    getStateByCID(id);
  };

  const [countrylist, setCountrylist] = useState([]);
  const [state, setState] = useState("");
  const [statelist, setStatelist] = useState([]);
  const getStateByCID = async (id) => {
    const response = await fetch(
      SERVER_URL + `api/common/state?countryId=${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setStatelist(data.result);
        }
      });
  };

  const HandleCompany = (e) => {
    setCompany(e.target.value);
    let cid = "";
    if (e.target.value == 1 || e.target.value == 2) {
      cid = "1";
    }
    if (e.target.value == 3 || e.target.value == 5) {
      cid = "2";
    }
    if (e.target.value == 6) {
      cid = "3";
    }
    setCountry(cid);
    handleCountry(cid);
  };

  const getCountryList = () => {
    const response = fetch(SERVER_URL + `api/common/country_list`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setComplist(data.result);
          setCountrylist(data.result);
        }
      });
  };

  const [errstate, setErrstate] = useState("");
  const HandleState = (e) => {
    setState(e.target.value);
    getWorkLocation(e.target.value);
  };
  useEffect(() => {
    getWorkLocation(state);
  }, [state]);
  useEffect(() => {
    setCompany(company);
    let cid = "";
    if (company == 1 || company == 2) {
      cid = "1";
    }
    if (company == 3 || company == 5) {
      cid = "2";
    }
    if (company == 6) {
      cid = "3";
    }
    handleCountry(cid);
  }, [company]);

  const HandleDateOfJoining = (e) => {
    setDateofjoining(e.target.value);
    const period = new Date(e.target.value);
    const end = addMonths(period, 6);
    const confDate = format(end, "yyyy-MM-dd");
    setConfirmationdate(confDate);

    var date1 = new Date(dateofjoining);
    var date2 = new Date(confirmationdate);
    if (dateofjoining) {
      var year1 = date1.getFullYear();
      var year2 = date2.getFullYear();
      var month1 = date1.getMonth();
      var month2 = date2.getMonth();
      const numberOfMonths = (year2 - year1) * 12 + (month2 - month1);
      setProbation_period(numberOfMonths);
    }
  };
  const HandleConfirmationDate = (e) => {
    setConfirmationdate(e.target.value);
    var date1 = new Date(dateofjoining);
    var date2 = new Date(confirmationdate);

    if (dateofjoining) {
      var year1 = date1.getFullYear();
      var year2 = date2.getFullYear();
      var month1 = date1.getMonth();
      var month2 = date2.getMonth();
      const numberOfMonths = (year2 - year1) * 12 + (month2 - month1);
      setProbation_period(numberOfMonths);
    }
  };
  const HandleSystemRole = (e) => {
    setSystemRole(e.target.value);
    if (e.target.value == 1) {
      setNoticeperiod("30");
    } else {
      setNoticeperiod("60");
    }
  };
  const HandleAdhaar = (e) => {
    if (!isNaN(e.target.value) && e.target.value.length <= 12) {
      setAdhaarnumber(e.target.value);
    }
  };

  // more employement details
  //   const [records, setRecords] = useState([{ id: "", name: "",position:"",nameOfSup:"",numberOfSup:"",fromdate:"",todate:"",empctc:"",reasonleaving:"" }]);
  //   const [records, setRecords] = useState([]);
  const [comname, setComname] = useState("");
  const [titleOfposition, setTitleOfpostion] = useState("");
  const [nameOfsupervisor, setNameOfsupervisor] = useState("");
  const [numberOfsupervisor, setNumberOfsupervisor] = useState("");
  const [empFromDate, setEmpFromDate] = useState("");
  const [empToDate, setEmpToDate] = useState("");
  const [empctc, setEmpctc] = useState("");
  const [cmpadd, setCmpadd] = useState("");
  const [reasonLeaving, setReasonLeaving] = useState("");
  const [uploadedRelivingLetter, setUploadedRelivingLetter] = useState("");
  const [err_uploadedRelivingLetter, setErr_uploadedRelivingLetter] =
    useState("");

  //   const [indkey,setIndkey]  = useState(1);

  const [uploadedUppointmentLetter, setUploadedUppointmentLetter] =
    useState("");
  const [err_uploadedUppointmentLetter, setErr_uploadedUppointmentLetter] =
    useState("");
  const handleAppointmentLetterUpload = (e) => {
    setErr_appointmentfile("");
    setErr_uploadedUppointmentLetter("");
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setErr_uploadedUppointmentLetter("File must be less than 2MB");
        e.target.value = ""; // reset input
        return;
      }
      const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      if (!allowedTypes.includes(file.type)) {
        setErr_uploadedUppointmentLetter(
          "Allowed Only PDF, JPG, and PNG files",
        );
        e.target.value = ""; // reset input
        return;
      }
      setUploadedUppointmentLetter(file);
    }
  };
  const handleReleavingLetterUpload = (e) => {
    setErr_releavingfile("");
    setErr_uploadedRelivingLetter("");
    const fileRelivingLetter = e.target.files[0];
    if (fileRelivingLetter) {
      if (fileRelivingLetter.size > 2 * 1024 * 1024) {
        setErr_uploadedRelivingLetter("File must be less than 2MB");
        e.target.value = ""; // reset input
        return;
      }
      const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      if (!allowedTypes.includes(fileRelivingLetter.type)) {
        setErr_uploadedRelivingLetter("Allowed Only PDF, JPG, and PNG files");
        e.target.value = ""; // reset input
        return;
      }
      setUploadedRelivingLetter(fileRelivingLetter);
    }
  };

  const [empExp, setEmpExp] = useState([]);

  const [err_company, setErr_company] = useState("");
  const [err_position, setErr_position] = useState("");
  const [err_supervisor, setErr_supervisor] = useState("");
  const [err_supervisor_number, setErr_supervisor_number] = useState("");
  const [err_empfromdate, setErr_empfromdate] = useState("");
  const [err_emptodate, setErr_emptodate] = useState("");
  const [err_empctc, setErr_empctc] = useState("");
  const [err_cmpadd, setErr_cmpadd] = useState("");
  const [err_appointmentfile, setErr_appointmentfile] = useState("");
  const [err_releavingfile, setErr_releavingfile] = useState("");

  function validateFile(file) {
    setErr_appointmentfile("");
    const allowedExtensions = /\.(jpg|jpeg|png|pdf|docx)$/i;
    const maxSizeInMB = 2;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    if (!file || file === null || file === undefined) {
      return {
        valid: false,
        message: "No file selected.",
      };
    }
    if (!allowedExtensions.test(file.name)) {
      return {
        valid: false,
        message: "Allowed: jpg, jpeg, png, pdf, docx",
      };
    }

    if (file.size > maxSizeInBytes) {
      return { valid: false, message: `File size exceeds ${maxSizeInMB}MB` };
    }

    return { valid: true, message: "File is valid" };
  }

  const addRecord = async () => {
    setErr_uploadedRelivingLetter("");
    setErr_uploadedUppointmentLetter("");
    setErr_company("");
    setErr_position("");
    setErr_supervisor("");
    setErr_supervisor_number("");
    setErr_empfromdate("");
    setErr_emptodate("");
    setErr_empctc("");
    setErr_cmpadd("");
    setErr_appointmentfile("");
    setErr_releavingfile("");

    const regexText = /^[a-zA-Z0-9 ]+$/;
    const regexPhone = /^\d{6,15}$/;
    const regexnumber = /^(\d+\.?\d*|\.\d+)$/;
    const regex_add = /^[a-zA-Z0-9\s.,\-\/#()'&]+$/;
    if (!regexText.test(comname.trim())) {
      setErr_company("required");
      return false;
    }

    if (!regexText.test(titleOfposition.trim())) {
      setErr_position("required");
      return false;
    }

    if (!regexText.test(nameOfsupervisor.trim())) {
      setErr_supervisor("required");
      return false;
    }

    if (!regexPhone.test(numberOfsupervisor.trim())) {
      setErr_supervisor_number("required");
      return false;
    }
    if (empFromDate == "") {
      setErr_empfromdate("required");
      return false;
    }
    if (empToDate == "") {
      setErr_emptodate("required");
      return false;
    }
    if (!regexnumber.test(empctc.trim())) {
      setErr_empctc("required");
      return false;
    }
    if (!regex_add.test(cmpadd.trim())) {
      setErr_cmpadd("required");
      return false;
    } else {
      const file_rel = relavingLetterRef.current?.files[0];
      const result2 = validateFile(file_rel);
      if (!result2.valid) {
        setErr_releavingfile(result2.message);
        return false;
      }

      const file = appointmentLetterRef.current?.files[0];
      const result1 = validateFile(file);
      if (!result1.valid) {
        setErr_appointmentfile(result1.message);
        return false;
      }

      const formData = new FormData();
      formData.append("appointmentfile", uploadedUppointmentLetter); // `uploadedUppointmentLetter` must be a File object
      formData.append("relivingLetter", uploadedRelivingLetter); // `uploadedUppointmentLetter` must be a File object

      try {
        const user_login_id = localStorage.getItem("userId");
        formData.append("emp_id", id);
        formData.append("created_by", user_login_id);
        formData.append("comname", comname);
        formData.append("titleOfposition", titleOfposition);
        formData.append("nameOfsupervisor", nameOfsupervisor);
        formData.append("numberOfsupervisor", numberOfsupervisor);
        formData.append("empFromDate", empFromDate);
        formData.append("empToDate", empToDate);
        formData.append("empctc", empctc);
        formData.append("cmpadd", cmpadd);
        formData.append("reasonLeaving", reasonLeaving);
        const response = await fetch(
          SERVER_URL + "api/employee/addemployementdetails",
          {
            method: "POST",
            headers: {
              Accept: "application/json", // ✅ Keep this
              Authorization: `Bearer ${token.value}`, // ✅ Bearer token capitalization
            },
            body: formData,
          },
        )
          .then((res) => res.json())
          .then((data) => {
            if (data.status == true) {
              previouscompempdetails();
              handlePreviousCompanyModalClose();
            }
          });
      } catch (err) {
        console.error("❌ Upload error:", err);
      }
    }
  };

  const deleteEmpPreviousComp = (id, status_id) => {
    if (status_id !== 0) {
      const response = fetch(
        SERVER_URL + `api/employee/deletepreviouscomdetail?id=${id}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `bearer ${token.value}`,
          },
        },
      )
        .then((res) => res.json())
        .then((data) => {
          previouscompempdetails();
        });
    }
    // setEmpExp((prev) => {
    //     const updated = prev.filter((item) => item.id !== id);
    //     setRecords(updated);
    //     return updated;
    //   });
  };

  const handleSalarySlipOne = (e) => {
    setErr_empslip1("");
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setErr_empslip1("File must be less than 2MB");
        e.target.value = ""; // reset input
        return;
      }

      const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      if (!allowedTypes.includes(file.type)) {
        setErr_empslip1("Allowed Only PDF, JPG, and PNG files");
        e.target.value = ""; // reset input
        return;
      }
      uploadslips(file, "slip1", emp_id);
    }
  };

  const handleSalarySlipTwo = (e) => {
    const file = e.target.files[0];
    setErr_empslip2("");
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setErr_empslip2("File must be less than 2MB");
        e.target.value = ""; // reset input
        return;
      }
      const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      if (!allowedTypes.includes(file.type)) {
        setErr_empslip2("Allowed Only PDF, JPG, and PNG files");
        e.target.value = ""; // reset input
        return;
      }
      uploadslips(file, "slip2", emp_id);
    }
  };
  const handleSalarySlipThree = (e) => {
    const file = e.target.files[0];
    setErr_empslip3("");
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        setErr_empslip3("File must be less than 2MB");
        e.target.value = ""; // reset input
        return;
      }
      const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      if (!allowedTypes.includes(file.type)) {
        setErr_empslip3("Allowed Only PDF, JPG, and PNG files");
        e.target.value = ""; // reset input
        return;
      }
      uploadslips(file, "slip3", emp_id);
    }
  };

  const uploadslips = async (file, fieldName, emp_id) => {
    const formData = new FormData();
    formData.append("uploadslip", file);
    formData.append("fieldName", fieldName);
    formData.append("emp_id", emp_id);
    const response = await fetch(SERVER_URL + "api/employee/addsallaryslips", {
      method: "POST",
      headers: {
        Accept: "application/json", // ✅ Keep this
        Authorization: `Bearer ${token.value}`, // ✅ Bearer token capitalization
      },
      body: formData,
    });
    const result = await response.json();
    if (result.status == true) {
      getsalarySlip(fieldName);
    }
  };
  useEffect(() => {
    getsalarySlip("slip1");
  }, []);
  useEffect(() => {
    getsalarySlip("slip2");
  }, []);
  useEffect(() => {
    getsalarySlip("slip3");
  }, []);

  const [empslip1, setEmpslip1] = useState("");
  const [empslip2, setEmpslip2] = useState("");
  const [empslip3, setEmpslip3] = useState("");

  const [err_empslip1, setErr_empslip1] = useState("");
  const [err_empslip2, setErr_empslip2] = useState("");
  const [err_empslip3, setErr_empslip3] = useState("");
  const getsalarySlip = (fieldName) => {
    const response = fetch(SERVER_URL + `api/employee/getEmpslip`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        emp_id: id,
        fieldName: fieldName,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true && fieldName == "slip1") {
          setEmpslip1(data.data[fieldName]);
        }
        if (data.status == true && fieldName == "slip2") {
          setEmpslip2(data.data[fieldName]);
        }
        if (data.status == true && fieldName == "slip3") {
          setEmpslip3(data.data[fieldName]);
        }
        if (data.status == true && fieldName == "Passportno") {
          setUploadpassport(data.data[fieldName]);
        }
      });
  };
  const deleteslip = (filedName) => {
    const response = fetch(SERVER_URL + `api/employee/deleteEmpslip`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        emp_id: id,
        filedName: filedName,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          if (filedName == "Passportno") {
            setUploadpassport("");
          }
          if (filedName == "Passportno") {
            setUploadpassport("");
          }
          if (filedName == "AddressProof") {
            setUploadaddressproof("");
          }
          if (filedName == "AadharcardFiles") {
            setUploadaadharcard("");
          }
          if (filedName == "pan_card") {
            setUploadpancard("");
          }
          if (filedName == "PassportSizePhoto") {
            setUploadphotgraph("");
          }
          if (filedName == "slip1") {
            setEmpslip1("");
          }
          if (filedName == "slip2") {
            setEmpslip2("");
          }
          if (filedName == "slip3") {
            setEmpslip3("");
          }
        }
      });
  };

  const [familymembername, setFamilymembername] = useState("");
  const [err_familymembername, setErr_familymembername] = useState("");

  const [familymemberrelation, setFamilymemberrelation] = useState("");
  const [err_familymemberrelation, setErr_familymemberrelation] = useState("");

  const [familymemberdob, setFamilymemberdob] = useState("");
  const [err_familymemberdob, setErr_familymemberdob] = useState("");

  const [familymemberage, setFamilymemberage] = useState("");
  const [familymemberaccupation, setFamilymemberaccupation] = useState("");
  const [err_familymemberaccupation, setErr_familymemberaccupation] =
    useState("");
  function calculateAge(dateString) {
    const birthDate = new Date(dateString);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
  const handleAge = (e) => {
    setFamilymemberdob(e.target.value);
    const age = calculateAge(e.target.value);
    setFamilymemberage(age);
  };

  const saveFamilydetails = () => {
    setErr_familymembername("");
    setErr_familymemberrelation("");
    setErr_familymemberdob("");
    setErr_familymemberaccupation("");

    const regexText = /^[a-zA-Z0-9 ]+$/;
    if (!regexText.test(familymembername.trim())) {
      setErr_familymembername("required");
      return false;
    }
    if (!regexText.test(familymemberrelation.trim())) {
      setErr_familymemberrelation("required");
      return false;
    }
    if (
      familymemberdob == "" ||
      familymemberdob == null ||
      familymemberdob == undefined
    ) {
      setErr_familymemberdob("required");
      return false;
    }
    if (!regexText.test(familymemberaccupation.trim())) {
      setErr_familymemberaccupation("required");
      return false;
    } else {
      const user_login_id = localStorage.getItem("userId");
      const response = fetch(SERVER_URL + `api/employee/addfamilydetails`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          authorization: `bearer ${token.value}`,
        },
        body: JSON.stringify({
          emp_id: id,
          name: familymembername,
          relation: familymemberrelation,
          dob: familymemberdob,
          age: familymemberage,
          accupation: familymemberaccupation,
          created_by: user_login_id,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status == true) {
            setModal(false);
            getFamilyMembersDetails();
          }
        });
    }
  };
  const [familymemberlist, setFamilymemberlist] = useState([]);
  useEffect(() => {
    getFamilyMembersDetails();
  }, []);
  const getFamilyMembersDetails = () => {
    const response = fetch(SERVER_URL + `api/employee/getEmpmemberdetails`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        emp_id: id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setFamilymemberlist(data?.data);

          setFamilymembername("");
          setFamilymemberrelation("");
          setFamilymemberdob("");
          setFamilymemberage("");
          setFamilymemberaccupation("");
          // const modalElement = document.getElementById("addfamilydetail");
          // if (modalElement) {
          //   const modalInstance =
          //     window.bootstrap?.Modal.getInstance(modalElement) ||
          //     new window.bootstrap.Modal(modalElement);
          //   modalInstance.hide();
          //   document.body.classList.remove("modal-open");
          //   document
          //     .querySelectorAll(".modal-backdrop")
          //     .forEach((el) => el.remove());
          // }
        }
      });
  };

  const deletefamilymember = (id) => {
    const response = fetch(SERVER_URL + `api/employee/deleteEmpmember`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        id: id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          getFamilyMembersDetails();
        }
      });
  };

  const [modal, setModal] = useState(false);
  const handleClose = () => {
    setErr_familymembername("");
    setErr_familymemberrelation("");
    setErr_familymemberdob("");
    setErr_familymemberaccupation("");
    setModal(false);
  };
  const handleShowModal = () => {
    setModal(true);
  };

  const [qualificationmodal, setQualificationmodal] = useState(false);
  const handleShowModalqualification = () => {
    setQualificationmodal(true);
  };
  const handlequalificationClose = () => {
    setQualificationmodal(false);
    setEmpInstitutions("");
    setEmpInsfromdate("");
    setEmpInstodate("");
    setEmpInstdegree("");
    setEmpInstsubject("");
    setInsdocument("");
  };

  const [empInstitutions, setEmpInstitutions] = useState("");
  const [err_empInstitutions, setErr_empInstitutions] = useState("");

  const [empInsfromdate, setEmpInsfromdate] = useState("");
  const [err_empInsfromdate, setErr_empInsfromdate] = useState("");

  const [empInstodate, setEmpInstodate] = useState("");
  const [err_empInstodate, setErr_empInstodate] = useState("");

  const [empInstdegree, setEmpInstdegree] = useState("");
  const [err_empInstdegree, setErr_empInstdegree] = useState("");

  const [empInstsubject, setEmpInstsubject] = useState("");
  const [err_empInstsubject, setErr_empInstsubject] = useState("");

  const [insdocument, setInsdocument] = useState("");
  const [err_insdocument, setErr_insdocument] = useState("");
  const handleAddQualification = () => {
    const regexText = /^[a-zA-Z0-9 .,]+$/;
    const documentRegex = /\.(pdf|jpg|jpeg|png)$/i;
    setErr_empInstitutions("");
    setErr_empInsfromdate("");
    setErr_empInstodate("");
    setErr_empInstdegree("");
    setErr_empInstsubject("");
    setErr_insdocument("");
    if (!regexText.test(empInstitutions.trim())) {
      setErr_empInstitutions("required");
      return false;
    }
    if (
      empInsfromdate == "" ||
      empInsfromdate == null ||
      empInsfromdate == undefined
    ) {
      setErr_empInsfromdate("required");
      return false;
    }
    if (
      empInstodate == "" ||
      empInstodate == null ||
      empInstodate == undefined
    ) {
      setErr_empInstodate("required");
      return false;
    }
    if (!regexText.test(empInstdegree.trim())) {
      setErr_empInstdegree("required");
      return false;
    }
    if (!regexText.test(empInstsubject.trim())) {
      setErr_empInstsubject("required");
      return false;
    }
    if (!documentRegex.test(insdocument.name)) {
      setErr_insdocument("required");
      return false;
    } else {
      try {
        const formData = new FormData();
        formData.append("insdocument", insdocument);
        const user_login_id = localStorage.getItem("userId");
        formData.append("created_by", user_login_id);
        formData.append("emp_id", id);
        formData.append("name", empInstitutions);
        formData.append("fromyear", new Date(empInsfromdate).getFullYear());
        formData.append("todate", new Date(empInstodate).getFullYear());
        formData.append("empInstdegree", empInstdegree);
        formData.append("empInstsubject", empInstsubject);
        const response = fetch(
          SERVER_URL + "api/employee/addemployementinstitutedetails",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token.value}`,
            },
            body: formData,
          },
        )
          .then((res) => res.json())
          .then((data) => {
            if (data.status == true) {
              getQualification();
              handlequalificationClose();
            }
          });
      } catch (err) {}
    }
  };

  const handleUploadDocument = (e) => {
    setErr_insdocument("");
    const empinstitutedocument = e.target.files[0];
    if (empinstitutedocument) {
      if (empinstitutedocument.size > 2 * 1024 * 1024) {
        setErr_insdocument("File must be less than 2MB");
        e.target.value = ""; // reset input
        return;
      }
      const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      if (!allowedTypes.includes(empinstitutedocument.type)) {
        setErr_insdocument("Allowed Only PDF, JPG, and PNG files");
        e.target.value = ""; // reset input
        return;
      }
      setInsdocument(empinstitutedocument);
    }
  };
  useEffect(() => {
    getQualification();
  }, []);
  const [empqualificationlist, setEmpqualificationlist] = useState([]);
  const getQualification = () => {
    const response = fetch(SERVER_URL + `api/employee/getEmpqualification`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        emp_id: id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setEmpqualificationlist(data?.results);
        }
      });
  };
  const removeQualification = (id) => {
    const response = fetch(SERVER_URL + `api/employee/deletequalification`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        id: id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          getQualification();
        }
      });
  };

  const [previousCompanymodal, setPreviousCompanymodal] = useState(false);
  const handlePreviousCompanyModal = () => {
    setPreviousCompanymodal(true);
  };

  const handlePreviousCompanyModalClose = () => {
    setPreviousCompanymodal(false);
    setComname("");
    setTitleOfpostion("");
    setNameOfsupervisor("");
    setNumberOfsupervisor("");
    setEmpFromDate("");
    setEmpToDate("");
    setEmpctc("");
    setCmpadd("");
    setReasonLeaving("");
    setUploadedRelivingLetter("");
  };

  const [uploadpassport, setUploadpassport] = useState("");
  const handlePassport = (e) => {
    const file = e.target.files[0];
    const field_name = "Passportno";
    uploadFiles(file, field_name, setUploadpassport);
  };
  const uploadFiles = async (file, field_name, stateSetter) => {
    const formData = new FormData();
    formData.append("field_name", field_name);
    formData.append(field_name, file);
    formData.append("emp_id", id);

    const response = await fetch(SERVER_URL + "api/employee/uploadsfiles", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token.value}`,
      },
      body: formData,
    });
    const result = await response.json();
    if (result.status == true) {
      stateSetter(result.msg);
    }
  };
  const [uploadaddressproof, setUploadaddressproof] = useState("");
  const handleAddressProof = (e) => {
    const file = e.target.files[0];
    const field_name = "AddressProof";
    uploadFiles(file, field_name, setUploadaddressproof);
  };

  const [uploadphotgraph, setUploadphotgraph] = useState("");
  const handlePhotoGraph = (e) => {
    const file = e.target.files[0];
    const field_name = "PassportSizePhoto";
    uploadFiles(file, field_name, setUploadphotgraph);
  };

  const [uploadpancard, setUploadpancard] = useState("");
  const handlePanCard = (e) => {
    const file = e.target.files[0];
    const field_name = "pan_card";
    uploadFiles(file, field_name, setUploadpancard);
  };

  const [uploadaadharcard, setUploadaadharcard] = useState("");
  const handleAadharCard = (e) => {
    const file = e.target.files[0];
    const field_name = "AadharcardFiles";
    uploadFiles(file, field_name, setUploadaadharcard);
  };

  return (
    <>
      <div className="page-header">
        <h1>Edit Employee</h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li>
            <Link to="/employeelist">
              <span>/</span>Employee List{" "}
            </Link>
          </li>
          <li className="current">
            <span>/</span>Edit Employee
          </li>
        </ul>
      </div>

      <div className="row_bg">
        <div className="profile_wrapper">
          <div
            className="nav"
            id="profile-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <Link
              className="nav-link active"
              id="employmentprofile-tab"
              data-bs-toggle="tab"
              href="#employmentprofile"
              data-bs-target="#employmentprofile"
            >
              Employment Profile
            </Link>
            <span className="middleline"></span>
            <Link
              className="nav-link"
              id="employmentspecifics-tab"
              data-bs-toggle="tab"
              href="#employmentspecifics"
              data-bs-target="#employmentspecifics"
            >
              Employment Detail
            </Link>
            <span className="middleline"></span>
            <Link
              className="nav-link"
              id="detail-tab"
              data-bs-toggle="tab"
              href="#detail"
              data-bs-target="#detail"
            >
              Bank Detail
            </Link>

            <span className="middleline"></span>
            <Link
              className="nav-link"
              id="empfamily-tab"
              data-bs-toggle="tab"
              href="#empfamily"
              data-bs-target="#empfamily"
            >
              Family & Qualification Detail
            </Link>

            <span className="middleline"></span>
            <Link
              className="nav-link"
              id="empprevious-tab"
              data-bs-toggle="tab"
              href="#empprevious"
              data-bs-target="#empprevious"
            >
              Previous Employment Detail
            </Link>
            {/* <span className="middleline"></span>
                        <Link className="nav-link" id="skill-tab" data-bs-toggle="tab" href="#skillset" data-bs-target="#skillset">
                            Skill Set
                        </Link> */}
          </div>
        </div>
        <div className="tab-content tab_content_fs12" id="profile-tabContent">
          <div
            className="tab-pane fade show active"
            id="employmentprofile"
            role="tabpanel"
            aria-labelledby="employmentprofile-tab"
          >
            <div className="tab_content">
              <div className="tab_sub_ttl">Organization</div>
              <div className="row mb25">
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Company <sup className="error_mgs"> *</sup>
                    </div>
                    <div className="form-input col-md-8">
                      <select
                        style={{ borderColor: `${errcompany}` }}
                        ref={companyRef}
                        value={company ?? ""}
                        onChange={HandleCompany}
                        className="form-select"
                      >
                        <option defaultValue="">Select Company</option>
                        {comdata?.map((item, ind) => (
                          <option key={ind} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Division <sup className="error_mgs"> *</sup>
                    </div>
                    <div className="form-input col-md-8">
                      <select
                        ref={roleRef}
                        style={{ borderColor: `${errrole}` }}
                        value={role ?? ""}
                        onChange={(e) => handleDepartment(e.target.value)}
                        className="form-select"
                      >
                        <option defaultValue="">Select Division</option>
                        {depdata?.map((item, ind) => (
                          <option key={ind} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {sub_dept_status == "block" && (
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Department <sup className="error_mgs"> *</sup>
                      </div>
                      <div className="form-input col-md-8 addnew_wrapper">
                        <select
                          style={{ borderColor: `${errsub_role}` }}
                          ref={sub_roleRef}
                          value={sub_role ?? ""}
                          onChange={(e) => setSub_Role(e.target.value)}
                          className="form-select ucwords"
                        >
                          <option defaultValue="">Select Department</option>
                          {roledata?.map((item, ind) => (
                            <option key={ind} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                        <button
                          className="addnew_btn"
                          onClick={handleAddSubRole}
                        >
                          {" "}
                          Add New
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {sub_dept_status == "none" && (
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Department</div>
                      <div className="form-input col-md-8 addnew_wrapper1">
                        <input
                          style={{ borderColor: `${errsubrole}` }}
                          type="text"
                          value={newSubrole ?? ""}
                          onChange={(e) => setNewSubrole(e.target.value)}
                          placeholder="Enter Department"
                          className="form-control form-control1"
                        />
                        <button
                          className="addnew_btn1"
                          onClick={handleSaveSubRole}
                        >
                          {" "}
                          Save
                        </button>
                        <button
                          className="cancelnew_btn"
                          onClick={handleCancelSubRole}
                        >
                          {" "}
                          Cancel
                        </button>
                        <div style={{ color: "red" }}>{errcheckrole}</div>
                      </div>
                    </div>
                  </div>
                )}
                {skill_status == "block" && (
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Skill <sup className="error_mgs"> *</sup>
                      </div>
                      <div className="form-input col-md-8 addnew_wrapper relative">
                        <span className="error_mgs1"></span>
                        <select
                          ref={skillRef}
                          style={{ borderColor: `${errSkill}` }}
                          value={skill ?? ""}
                          className="form-select ucwords"
                          onChange={(e) => setSkill(e.target.value)}
                        >
                          <option defaultValue="">Select Skill</option>
                          {skillList?.map((item, i) => (
                            <option value={item.id} key={i}>
                              {item.name}
                            </option>
                          ))}
                        </select>
                        <button className="addnew_btn" onClick={handleAddSkill}>
                          {" "}
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {skill_status == "none" && (
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4"> Skill</div>
                      <div className="form-input col-md-8 addnew_wrapper1">
                        <input
                          style={{ borderColor: `${errskill}` }}
                          type="text"
                          value={newSkill ?? ""}
                          onChange={(e) => setNewSkill(e.target.value)}
                          placeholder="Enter skill"
                          className="form-control form-control1"
                        />
                        <button
                          className="addnew_btn1"
                          onClick={handleSaveSkill}
                        >
                          {" "}
                          Save
                        </button>
                        <button
                          className="cancelnew_btn"
                          onClick={handleCancelSkill}
                        >
                          {" "}
                          Cancel
                        </button>
                        <div style={{ color: "red" }}>{errcheckskill}</div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Employment Mode <sup className="error_mgs"> *</sup>
                    </div>
                    <div className="form-input col-md-8">
                      <select
                        disabled
                        ref={empcategoryRef}
                        style={{ borderColor: `${errempcategory}` }}
                        value={empcategory ?? ""}
                        onChange={(e) => setEmpcategory(e.target.value)}
                        className="form-select"
                      >
                        <option defaultValue="">Select Employment Mode</option>
                        <option value="1">Payroll</option>
                        <option value="2">Contract</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      System Role <sup className="error_mgs"> *</sup>
                    </div>
                    <div className="form-input col-md-8">
                      <select
                        ref={systemRoleRef}
                        style={{ borderColor: `${errsystemRole}` }}
                        onChange={HandleSystemRole}
                        value={systemRole ?? ""}
                        className="form-select"
                      >
                        <option>Select System Role</option>
                        {system_role?.map((item, ind) => (
                          <option key={ind} value={item.id}>
                            {item.role}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4 pr00">
                      Assign User to Department
                    </div>
                    <div className="form-input col-md-8">
                      {/* <Select
                        options={dept}
                        value={selectedOptions} // MUST be array of {value,label}
                        onChange={(selected) => {
                          const opts = selected || [];
                          setSelectedOptions(opts); // Store full objects
                          setDeptIds(opts.map((o) => o.value).join(","));
                        }}
                        isMulti
                        isClearable
                        isSearchable
                        placeholder="Assign User to Departments"
                      /> */}
                      <Select
                        options={dept}
                        value={selectedOptions}
                        onChange={(selected) => {
                          const options = selected || [];

                          setSelectedOptions(options);

                          const ids = options
                            .map((item) => item.value)
                            .join(",");

                          setDeptIds(ids);
                        }}
                        isMulti
                        isClearable
                        isSearchable
                        closeMenuOnSelect={false}
                        placeholder="Assign User to Departments"
                        classNamePrefix="department-select"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab_sub_ttl">Basic Info</div>
              <div className="row mb25">
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Salutation <sup className="error_mgs"> *</sup>
                    </div>
                    <div className="form-input col-md-8">
                      <select
                        ref={salutationRef}
                        style={{ borderColor: `${errsalutaion}` }}
                        value={salutation ?? ""}
                        onChange={(e) => {
                          setSalutation(e.target.value);
                        }}
                        className="form-select"
                      >
                        <option defaultValue="">Select</option>
                        <option value="1">Mr</option>
                        <option value="2">Ms</option>
                        <option value="3">Mrs</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      First Name <sup className="error_mgs"> *</sup>
                    </div>
                    <div className="form-input col-md-8">
                      <input
                        style={{ borderColor: `${errFname}` }}
                        ref={fnameRef}
                        autoComplete="none"
                        value={fname ?? ""}
                        onChange={(e) => {
                          setFname(e.target.value);
                        }}
                        type="text"
                        placeholder="Enter First Name"
                        className="form-control form-control1"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Middle Name</div>
                    <div className="form-input col-md-8">
                      <input
                        autoComplete="none"
                        value={mname ?? ""}
                        onChange={(e) => {
                          setMname(e.target.value);
                        }}
                        type="text"
                        placeholder="Enter Middle Name"
                        className="form-control form-control1"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Last Name</div>
                    <div className="form-input col-md-8">
                      <input
                        autoComplete="none"
                        value={lname ?? ""}
                        onChange={(e) => {
                          setLname(e.target.value);
                        }}
                        type="text"
                        placeholder="Enter Last Name"
                        className="form-control form-control1"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Personal Email</div>
                    <div className="form-input col-md-8">
                      <input
                        autoComplete="none"
                        value={persona_email ?? ""}
                        onChange={(e) => {
                          setPersonal_email(e.target.value);
                        }}
                        type="text"
                        placeholder="Enter Personal Email"
                        className="form-control form-control1 lowercase"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Alternate Email</div>
                    <div className="form-input col-md-8 relative">
                      <input
                        autoComplete="none"
                        value={alt_email ?? ""}
                        onChange={(e) => {
                          setAlt_email(e.target.value);
                        }}
                        type="text"
                        placeholder="Enter Alternate Email"
                        className="form-control form-control1 lowercase"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Contact Number</div>

                    <div className="form-input col-md-8 countrycode_wrp">
                      <select
                        value={countrycode ?? ""}
                        className="form-select"
                        onChange={(e) => setCountrycode(e.target.value)}
                      >
                        <option defaultValue="">Select</option>
                        {complist.map((item, i) => (
                          <option key={i} value={item.id}>
                            {item.phonecode}
                          </option>
                        ))}
                      </select>
                      <input
                        autoComplete="none"
                        value={contact_number ?? ""}
                        onChange={handleChangeNumber}
                        type="text"
                        placeholder="Enter Contact Number"
                        className="form-control form-control1 only-numeric"
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Official Email </div>
                                    <div className="form-input col-md-8">
                                        <input checked={officialemailstatus ? 'checked' : ''} onChange={handleEmail}  type="checkbox" /> Create Yes/No
                                    </div>
                                </div>
                            </div>
                        </div> */}
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Father/Husband</div>
                    <div className="form-input col-md-8">
                      <input
                        value={gargen ?? ""}
                        autoComplete="none"
                        onChange={(e) => {
                          setGargen(e.target.value);
                        }}
                        type="text"
                        placeholder="Enter Father/Husband Name"
                        className="form-control form-control1"
                      />
                    </div>
                  </div>
                </div>
                {country == 1 && (
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Gender</div>
                      <div className="form-input col-md-8">
                        <select
                          value={gender ?? ""}
                          onChange={(e) => {
                            setGender(e.target.value);
                          }}
                          className="form-select"
                        >
                          <option defaultValue="">Select Gender</option>
                          <option value="1">Male</option>
                          <option value="2">Female</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}

                {country == 1 && (
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Date Of Birth <sup className="error_mgs"> *</sup>
                      </div>
                      <div className="form-input col-md-8">
                        <input
                          ref={dateofbirthRef}
                          style={{ borderColor: `${errdateofbirth}` }}
                          onChange={(e) => {
                            setDateofbirth(e.target.value);
                          }}
                          type="date"
                          className="form-control"
                          name=""
                          value={dateofbirth ?? ""}
                          placeholder="Select Date Of Birth"
                        />
                      </div>
                    </div>
                  </div>
                )}
                {country == 1 && (
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Marital Status</div>
                      <div className="form-input col-md-8">
                        <select
                          value={marriage ?? ""}
                          onChange={(e) => setMarriage(e.target.value)}
                          className="form-select"
                        >
                          <option defaultValue="">Select Marital Status</option>
                          <option value="1">Married</option>
                          <option value="2">Unmarried</option>
                          <option value="3">Other</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
                {marriage == 1 && (
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Anniversary Date
                      </div>
                      <div className="form-input col-md-8 relative">
                        <input
                          value={dateofwedding ?? ""}
                          onChange={(e) => {
                            setDateofwedding(e.target.value);
                          }}
                          type="date"
                          className="form-control"
                          name=""
                          placeholder=""
                        />
                      </div>
                    </div>
                  </div>
                )}
                {country == 1 && (
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Blood Group</div>
                      <div className="form-input  col-md-8">
                        <input
                          type="text"
                          value={bloodgroup ?? ""}
                          onChange={(e) => setBloodgroup(e.target.value)}
                          placeholder="Enter Blood Group"
                          className="form-control form-control1"
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Hobbies </div>
                    <div className="form-input col-md-8">
                      <input
                        onChange={(e) => setHobbies(e.target.value)}
                        value={hobbies ?? ""}
                        type="text"
                        placeholder="Enter Hobbies"
                        className="form-control form-control1"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Weight <sup>( Kg )</sup>{" "}
                    </div>
                    <div className="form-input col-md-8">
                      <input
                        value={weight ?? ""}
                        onChange={(e) => setWeight(e.target.value)}
                        type="text"
                        placeholder="Enter Weight"
                        className="form-control form-control1"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Height <sup>( inches )</sup>{" "}
                    </div>
                    <div className="form-input col-md-8">
                      <input
                        type="text"
                        placeholder="Enter Height"
                        className="form-control form-control1"
                        value={height ?? ""}
                        onChange={(e) => setHeight(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Nationality: {nationality}
                    </div>
                    <div className="form-input col-md-8">
                      <input
                        type="text"
                        placeholder="Enter Nationality"
                        className="form-control form-control1"
                        value={nationality ?? ""}
                        onChange={(e) => setNationality(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {/* <div className="col-md-6"> 
                                    <div className="form-blk row mb25">
                                        <div className="form-label col-md-4">Nationality</div>
                                        <div className="form-input col-md-8">
                                            <input type="text" value={nationality} onChange={(e) => setNationality(e.target.value)} placeholder="Enter Nationality" className="form-control form-control1" />
                                        </div>
                                    </div>
                                </div> */}
                {/* <div className="col-md-6">
                                    <div className="form-blk row">
                                        <div className="form-label col-md-4">Aadhaar Name </div>
                                        <div className="form-input col-md-8">
                                            <input type="text" value={adhaarname} onChange={(e) => setAdhaarname(e.target.value)} placeholder="Enter Aadhaar Card Name" className="form-control form-control1" />
                                        </div>
                                    </div>
                                </div> */}
                {country == 1 && (
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Aadhaar Number</div>
                      <div className="form-input col-md-8">
                        <input
                          type="text"
                          value={adhaarnumber ?? ""}
                          onChange={HandleAdhaar}
                          placeholder="Enter Aadhaar Card Number"
                          className="form-control form-control1"
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Upload Aadhaar Card
                    </div>
                    <div className="form-input col-md-8">
                      {uploadaadharcard && (
                        <>
                          <a
                            className="btn_7 mr03"
                            href={`${SERVER_URL}uploads/emp_proof/${uploadaadharcard}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i class="icon icon-eye mr03"></i> View File
                          </a>
                          <button
                            className="btn_8 small_btn"
                            onClick={() => deleteslip("AadharcardFiles")}
                            title="Delete File"
                          >
                            <i class="icon icon-cross"></i>
                          </button>
                        </>
                      )}
                      {(uploadaadharcard == "" ||
                        uploadaadharcard == null ||
                        uploadaadharcard == undefined) && (
                        <input
                          type="file"
                          name="aadharcardfile"
                          className="form-control uploadbtn"
                          onChange={handleAadharCard}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      {country == 1 ? "Pan Number" : "SSN"}
                    </div>
                    <div className="form-input col-md-8">
                      <input
                        value={pancardnumber ?? ""}
                        onChange={(e) =>
                          setPancardnumber(e.target.value.toUpperCase())
                        }
                        type="text"
                        placeholder={`Enter ${
                          country == 1 ? "Pan Number" : "SSN"
                        }`}
                        className="form-control form-control1 uppercase"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Upload Pan Card</div>
                    <div className="form-input col-md-8">
                      {uploadpancard && (
                        <>
                          <a
                            className="btn_7 mr03"
                            href={`${SERVER_URL}uploads/emp_proof/${uploadpancard}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="icon icon-eye mr03"></i> View File
                          </a>
                          <button
                            className="btn_8 small_btn"
                            onClick={() => deleteslip("pan_card")}
                            title="Delete File"
                          >
                            <i class="icon icon-cross"></i>
                          </button>
                        </>
                      )}
                      {(uploadpancard == "" ||
                        uploadpancard == null ||
                        uploadpancard == undefined) && (
                        <input
                          type="file"
                          name="filepancard"
                          className="form-control uploadbtn"
                          onChange={handlePanCard}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Upload passport</div>

                    <div className="form-input col-md-8">
                      {uploadpassport && (
                        <>
                          <a
                            className="btn_7 mr03"
                            href={`${SERVER_URL}uploads/emp_proof/${uploadpassport}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="icon icon-eye mr03"></i> View File
                          </a>
                          <button
                            className="btn_8 small_btn"
                            onClick={() => deleteslip("Passportno")}
                            title="Delete File"
                          >
                            <i class="icon icon-cross"></i>
                          </button>
                        </>
                      )}
                      {(uploadpassport == "" ||
                        uploadpassport == null ||
                        uploadpassport == undefined) && (
                        <input
                          type="file"
                          name="passportnumber"
                          className="form-control uploadbtn"
                          onChange={handlePassport}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Photograph <sup>( Passport size )</sup>
                    </div>
                    <div className="form-input col-md-8">
                      {uploadphotgraph && (
                        <>
                          <a
                            className="btn_7 mr03"
                            href={`${SERVER_URL}uploads/emp_proof/${uploadphotgraph}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="icon icon-eye mr03"></i> View File
                          </a>
                          <button
                            className="btn_8 small_btn"
                            onClick={() => deleteslip("PassportSizePhoto")}
                            title="Delete File"
                          >
                            <i class="icon icon-cross"></i>
                          </button>
                        </>
                      )}
                      {(uploadphotgraph == "" ||
                        uploadphotgraph == null ||
                        uploadphotgraph == undefined) && (
                        <input
                          type="file"
                          name="passportsize"
                          className="form-control uploadbtn"
                          onChange={handlePhotoGraph}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Upload Address Proof
                    </div>
                    <div className="form-input col-md-8">
                      {uploadaddressproof && (
                        <>
                          <a
                            className="btn_7 mr03"
                            href={`${SERVER_URL}uploads/emp_proof/${uploadaddressproof}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="icon icon-eye mr03"></i> View File
                          </a>
                          <button
                            className="btn_8 small_btn"
                            onClick={() => deleteslip("AddressProof")}
                            title="Delete File"
                          >
                            <i class="icon icon-cross"></i>
                          </button>
                        </>
                      )}
                      {(uploadaddressproof == "" ||
                        uploadaddressproof == null ||
                        uploadaddressproof == undefined) && (
                        <input
                          type="file"
                          name=""
                          className="form-control uploadbtn"
                          onChange={handleAddressProof}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="tab_sub_ttl">Location</div>
              <div className="row mb25">
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Country</div>
                    <div className="form-input col-md-8">
                      <select
                        disabled
                        value={country ?? ""}
                        onChange={(e) => handleCountry(e.target.value)}
                        className="form-select"
                      >
                        <option defaultValue="">Select Country</option>
                        {countrylist.map((item, ind) => {
                          return (
                            <option key={ind} value={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Time Zone <sup className="error_mgs"> *</sup>
                    </div>
                    <div className="form-input col-md-8">
                      <select
                        style={{ borderColor: `${errtimeZone}` }}
                        ref={timezoneRef}
                        value={timezone ?? ""}
                        onChange={handelIsHiddenCountryWish}
                        className="form-select"
                      >
                        <option defaultValue="">Select Time Zone</option>
                        {locationlist?.map((item, ind) => (
                          <option key={ind} value={item.location_id}>
                            {item.name}-{item.timezone}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">State</div>
                    <div className="form-input col-md-8">
                      <select
                        style={{ borderColor: `${errstate}` }}
                        value={state ?? ""}
                        onChange={HandleState}
                        className="form-select ucwords"
                      >
                        <option defaultValue="">Select State</option>
                        {statelist.map((item, ind) => {
                          return (
                            <option key={ind} value={item.id}>
                              {item.name.toLowerCase()}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>

                {location_status == "block" && (
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Work Location</div>
                      <div className="form-input col-md-8 addnew_wrapper">
                        <select
                          className="form-select ucwords"
                          value={workplace ?? ""}
                          onChange={(e) => {
                            setWorkplace(e.target.value);
                          }}
                        >
                          <option defaultValue="">Select Shift</option>
                          {workLocationlist.map((item, ind) => {
                            return (
                              <option key={ind} value={item.id}>
                                {item.name}
                              </option>
                            );
                          })}
                        </select>
                        <button
                          className="addnew_btn"
                          onClick={handleWorkLocation}
                        >
                          {" "}
                          Add New
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {location_status == "none" && (
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">Work Location</div>
                      <div className="form-input col-md-8 addnew_wrapper1">
                        <input
                          ref={newworklocationRef}
                          style={{ borderColor: `${errwrklsn}` }}
                          type="text"
                          value={newworklocation ?? ""}
                          onChange={(e) => setNewworklocation(e.target.value)}
                          placeholder="Enter work location"
                          className="form-control form-control1"
                        />
                        <button
                          className="addnew_btn1"
                          onClick={handleSaveLocation}
                        >
                          {" "}
                          Save
                        </button>
                        <button
                          className="cancelnew_btn"
                          onClick={handleCancellocation}
                        >
                          {" "}
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Shift Time <sup className="error_mgs"> *</sup>
                    </div>
                    <div className="form-input col-md-8">
                      <select
                        style={{ borderColor: `${errshift}` }}
                        ref={empshiftRef}
                        value={shift ?? ""}
                        className="form-select"
                        onChange={(e) => {
                          setShift(e.target.value);
                        }}
                      >
                        <option defaultValue="">Select Shift</option>
                        {shiftList.map((item, ind) => {
                          return (
                            <option key={ind} value={item.id}>
                              {item.Name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab_sub_ttl">Emergency Contact</div>
              <div className="row mb25">
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Person</div>
                    <div className="form-input col-md-8">
                      <input
                        type="text"
                        placeholder="Enter Person"
                        className="form-control form-control1"
                        value={emercontactpersion ?? ""}
                        onChange={(e) => setEmercontactpersion(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Person Relationship
                    </div>
                    <div className="form-input col-md-8">
                      <input
                        type="text"
                        placeholder="Enter person Relationship"
                        className="form-control form-control1"
                        value={emercontactrelation ?? ""}
                        onChange={(e) => setEmercontactrelation(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Phone Number</div>
                    <div className="form-input col-md-8">
                      <input
                        type="text"
                        placeholder="Enter Phone Number"
                        className="form-control form-control1"
                        value={emercontactnumber ?? ""}
                        onChange={(e) => setEmercontactnumber(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab_sub_ttl mb00">Address</div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-blk mb10">
                    <div className="form-label">Current Address</div>
                    <div className="form-input  ">
                      <textarea
                        className="form-control"
                        onChange={(e) => setcurrenAdd(e.target.value)}
                        value={currenAdd ?? ""}
                      >
                        {" "}
                      </textarea>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk mb10">
                    <div className="form-label">Permanent Address</div>
                    <div className="form-input  ">
                      <textarea
                        onChange={(e) => setPermanentaddress(e.target.value)}
                        className="form-control form-control1"
                        value={permanentaddress ?? ""}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="employmentspecifics"
            role="tabpanel"
            aria-labelledby="employmentspecifics-tab"
          >
            <div className="tab_content">
              <div className="tab_sub_ttl">Employee Details</div>
              <div className="row mb25">
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Employee Code</div>
                    <div className="form-input col-md-8">
                      <input
                        type="text"
                        defaultValue={empcode ?? ""}
                        // onChange={(e) => setEmpcode(e.target.value)}
                        placeholder="Enter Employee Code"
                        className="form-control form-control1"
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Employee Status</div>
                    <div className="form-input col-md-8">
                      <select
                        value={empstatus ?? ""}
                        onChange={(e) => setEmpstatus(e.target.value)}
                        className="form-select"
                      >
                        <option defaultValue="">Select Employee Status</option>
                        <option value="1">Active</option>
                        <option value="2">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Date of joining: <sup className="error_mgs"> *</sup>
                    </div>
                    <div className="form-input col-md-8">
                      <input
                        ref={dateofjoiningRef}
                        style={{ borderColor: `${errdateofjoining}` }}
                        type="date"
                        value={dateofjoining ?? ""}
                        onChange={HandleDateOfJoining}
                        className="form-control"
                        placeholder="Select Date of joining"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4 pr07">
                      Probation Period (Month)
                    </div>
                    <div className="form-input col-md-8">
                      <input
                        type="text"
                        disabled
                        // onChange={(e) => setProbation_period(e.target.value)}
                        value={probation_period ?? ""}
                        placeholder="Enter Probation Period (Months)"
                        className="form-control form-control1"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">
                      Confirmation Date{" "}
                    </div>
                    <div className="form-input col-md-8">
                      <input
                        value={confirmationdate ?? ""}
                        onChange={HandleConfirmationDate}
                        type="date"
                        className="form-control"
                        placeholder="Select Confirmation Date"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4 pr07">
                      Notice Period (Days){" "}
                    </div>
                    <div className="form-input col-md-8">
                      <input
                        value={noticeperiod ?? ""}
                        disabled
                        // onChange={(e) => setNoticeperiod(e.target.value)}
                        type="text"
                        placeholder="Enter Notice Period"
                        className="form-control form-control1"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">First Reporting</div>
                    <div className="form-input col-md-8">
                      {/* <select value={reportingmanager} className="form-select" onChange={(e) => { setreportingmanager(e.target.value) }}>
                                                <option value=''>Select Reporting</option>
                                                {
                                                    reportimgManageList.map((item, ind) => {
                                                        return <option value={item.id}>{item.name}</option>
                                                    })
                                                }
                                            </select> */}
                      {/* <Select backspaceRemovesValue={false} controlShouldRenderValue={false}
          hideSelectedOptions={false}
          isClearable={false} tabSelectsValue={false}
          value={reportingmanager} placeholder="Search..." onChange={(e) => { setreportingmanager(e.value) }} options={reporting_option} /> */}

                      <Select
                        options={reporting_option || []}
                        value={
                          reporting_option?.find(
                            (option) => option.value === reportingmanager,
                          ) || null
                        }
                        onChange={(option) =>
                          setreportingmanager(option?.value ?? "")
                        }
                        isClearable
                        className="ucwords"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Final Reporting</div>
                    <div className="form-input col-md-8">
                      <Select
                        options={finalreport_option}
                        value={finalreport_option.find(
                          function (option) {
                            return option.value == finalReport;
                          } || null,
                        )}
                        onChange={(e) => {
                          setFinalReport(e.value);
                        }}
                        className="ucwords"
                      />
                    </div>
                  </div>
                </div>

                {empstatus == 2 && (
                  <div className="col-md-6">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-4">
                        Last Working Day:<sup className="error_mgs"> *</sup>
                      </div>
                      <div className="form-input col-md-8">
                        <input
                          ref={lastworkingdayRef}
                          style={{ borderColor: `${errlastworkingday}` }}
                          onChange={(e) => {
                            setLastWorkingday(e.target.value);
                          }}
                          type="date"
                          className="form-control"
                          name=""
                          value={lastWorkingday ?? ""}
                          placeholder="Select Last Working Day"
                        />
                      </div>
                    </div>
                  </div>
                )}
                {empstatus == 2 && (
                  <div className="col-md-12">
                    <div className="form-blk row mb25">
                      <div className="form-label col-md-2">Remark:</div>
                      <div className="form-input col-md-10">
                        <textarea
                          className="form-control"
                          cols="50"
                          rows="3"
                          value={text ?? ""}
                          onChange={(e) => setText(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="tab_sub_ttl">Skill</div>
              <div className="row mb25">
                <div className="col-md-6">
                  <div className="form-blk mb10">
                    <div className="form-label">Computer Skills</div>
                    <div className="form-input  ">
                      <textarea
                        onChange={(e) => setComputerSkills(e.target.value)}
                        className="form-control"
                        value={computerSkills ?? ""}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk mb10">
                    <div className="form-label">
                      Other Skills / Certifications
                    </div>
                    <div className="form-input">
                      <textarea
                        className="form-control form-control1"
                        onChange={(e) => setOtherSkills(e.target.value)}
                        value={otherSkills ?? ""}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <div className="tab_sub_ttl">Languages</div>
              <table className="monthly_table mt20">
                <thead>
                  <tr>
                    <th></th>
                    <th>Speak</th>
                    <th>Read</th>
                    <th>Write</th>
                    <th>Understand</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>English</td>
                    <td>
                      <select
                        className="form-select"
                        onChange={(e) => setSpeak1(e.target.value)}
                        value={speak1 ?? ""}
                      >
                        <option value="">Select Level</option>
                        <option value="1">Level I</option>
                        <option value="2">Level II</option>
                        <option value="3">Level III</option>
                      </select>
                    </td>
                    <td>
                      <select
                        className="form-select"
                        onChange={(e) => setRead1(e.target.value)}
                        value={read1 ?? ""}
                      >
                        <option value="">Select Level</option>
                        <option value="1">Level I</option>
                        <option value="2">Level II</option>
                        <option value="3">Level III</option>
                      </select>
                    </td>
                    <td>
                      <select
                        className="form-select"
                        onChange={(e) => setWrite1(e.target.value)}
                        value={write1 ?? ""}
                      >
                        <option value="">Select Level</option>
                        <option value="1">Level I</option>
                        <option value="2">Level II</option>
                        <option value="3">Level III</option>
                      </select>
                    </td>
                    <td>
                      <select
                        className="form-select"
                        onChange={(e) => setUnderstand1(e.target.value)}
                        value={understand1 ?? ""}
                      >
                        <option defaultValue="">Select Level</option>
                        <option value="1">Level I</option>
                        <option value="2">Level II</option>
                        <option value="3">Level III</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Hindi</td>
                    <td>
                      <select
                        className="form-select"
                        onChange={(e) => setSpeak2(e.target.value)}
                        value={speak2 ?? ""}
                      >
                        <option value="">Select Level</option>
                        <option value="1">Level I</option>
                        <option value="2">Level II</option>
                        <option value="3">Level III</option>
                      </select>
                    </td>
                    <td>
                      <select
                        className="form-select"
                        onChange={(e) => setRead2(e.target.value)}
                        value={read2 ?? ""}
                      >
                        <option value="">Select Level</option>
                        <option value="1">Level I</option>
                        <option value="2">Level II</option>
                        <option value="3">Level III</option>
                      </select>
                    </td>
                    <td>
                      <select
                        className="form-select"
                        onChange={(e) => setWrite2(e.target.value)}
                        value={write2 ?? ""}
                      >
                        <option value="">Select Level</option>
                        <option value="1">Level I</option>
                        <option value="2">Level II</option>
                        <option value="3">Level III</option>
                      </select>
                    </td>
                    <td>
                      <select
                        className="form-select"
                        onChange={(e) => setUnderstand2(e.target.value)}
                        value={understand2 ?? ""}
                      >
                        <option value="">Select Level</option>
                        <option value="1">Level I</option>
                        <option value="2">Level II</option>
                        <option value="3">Level III</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="4" className="green_mgs">
                      Note : Level I - Limited Knowledge , Level II - Good
                      Working Knowledge , Level III - Expertise
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="detail"
            role="tabpanel"
            aria-labelledby="detail-tab"
          >
            <div className="tab_content">
              <div className="tab_sub_ttl">Remuneration</div>
              <div className="row mb25">
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Salary Type</div>
                    <div className="form-input col-md-8">
                      <select
                        value={salaryType ?? ""}
                        onChange={(e) => {
                          setSalaryType(e.target.value);
                        }}
                        className="form-select"
                      >
                        <option value="">Select Salary Type</option>
                        <option value="1">Monthly Basis</option>
                        <option value="2">Daily Basis</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">CTC</div>
                    <div className="form-input col-md-8">
                      <input
                        type="text"
                        value={ctc ?? ""}
                        onChange={(e) => setCtc(e.target.value)}
                        placeholder="Enter CTC"
                        className="form-control form-control1"
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Actual MHR</div>
                    <div className="form-input col-md-8">
                      <input
                        type="text"
                        value={mhr ?? ""}
                        onChange={(e) => setMhr(e.target.value)}
                        placeholder="Enter Actual MHR"
                        className="form-control form-control1"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab_sub_ttl">Bank Details</div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Salary Bank</div>
                    <div className="form-input col-md-8">
                      <select
                        value={bankname ?? ""}
                        onChange={(e) => setBankname(e.target.value)}
                        className="form-select"
                      >
                        <option defaultValue="">Select Salary Type</option>
                        <option value="1">HDFC Bank</option>
                        <option value="2">Federal Bank</option>
                        <option value="3">IDFC FIRST Bank</option>
                        <option value="4">RBL Bank</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">Account Number</div>
                    <div className="form-input col-md-8">
                      <input
                        value={accountnumber ?? ""}
                        onChange={(e) => setAccountnumber(e.target.value)}
                        type="text"
                        placeholder="Enter Salary Account Number"
                        className="form-control form-control1"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">IFSC Code</div>
                    <div className="form-input col-md-8">
                      <input
                        value={ifsc ?? ""}
                        onChange={(e) => setIfsc(e.target.value.toUpperCase())}
                        type="text"
                        placeholder="Enter Salary IFSC Code"
                        className="form-control form-control1"
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-6">
                                    <div className="form-blk row mb25">
                                        <div className="form-label col-md-4">PF Applicable</div>
                                        <div className="form-input col-md-8">
                                            <select value={pfapplicable} onChange={(e) => setPfapplicable(e.target.value)} className="form-select">
                                                <option value=''>Select PF Applicable</option>
                                                <option value='1'>Yes</option>
                                                <option value='2'>No</option>
                                            </select>
                                        </div>
                                    </div>
                                </div> */}
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">PF Number</div>
                    <div className="form-input col-md-8">
                      <input
                        value={pfnumber ?? ""}
                        onChange={(e) => setPfnumber(e.target.value)}
                        type="text"
                        placeholder="Enter PF Number"
                        className="form-control form-control1"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">PF Group</div>
                    <div className="form-input col-md-8">
                      <select
                        value={pfgroup ?? ""}
                        onChange={(e) => setPfgroup(e.target.value)}
                        className="form-select"
                      >
                        <option defaultValue="">Select PF Group</option>
                        <option value="1">Yes</option>
                        <option value="2">No</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-blk row mb25">
                    <div className="form-label col-md-4">UAN Number</div>
                    <div className="form-input col-md-8">
                      <input
                        type="text"
                        value={uan_number ? uan_number : ""}
                        onChange={(e) => {
                          setUan_number(e.target.value);
                        }}
                        placeholder="Enter UAN Number"
                        className="form-control form-control1"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="empfamily"
            role="tabpanel"
            aria-labelledby="empfamily-tab"
          >
            <div className="tab_content">
              <button
                className="btn_5 float-end minus_mt15"
                onClick={handleShowModal}
              >
                Add Family Detail
              </button>

              <div className="tab_sub_ttl">Family Detail</div>
              <table className="monthly_table mt20 mb30">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Relationship</th>
                    <th>Age </th>
                    <th>Date of Birth</th>
                    <th>Occupation</th>
                    <th className="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {familymemberlist?.map((item, ind) => (
                    <tr key={ind}>
                      <td>{item.name}</td>
                      <td>{item.relation}</td>
                      <td>{item.age}</td>
                      <td>
                        {item.dob && moment(item.dob).format("DD MMM, YYYY")}
                      </td>
                      <td>{item.accupation}</td>
                      <td className="text-right">
                        <button
                          className="btn_8 small_btn"
                          onClick={(e) => deletefamilymember(item.id)}
                        >
                          <i className="icon icon-cross"></i>
                        </button>
                      </td>
                    </tr>
                  ))}

                  {(familymemberlist.length < 1 ||
                    familymemberlist.length == "" ||
                    familymemberlist.length == undefined) && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        <div className="notfound">No Record found</div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <button
                className="btn_5 float-end minus_mt15"
                onClick={handleShowModalqualification}
              >
                Add Qualification Detail
              </button>
              <div className="tab_sub_ttl">Qualification Detail</div>
              <table className="monthly_table mt20 mb25">
                <thead>
                  <tr rowSpan="2">
                    <th>Educational Institutions Name</th>
                    <th>From Date</th>
                    <th>To Date</th>
                    <th>Degree / Diploma Major Subjects </th>
                    <th>Major Subjects</th>
                    <th className="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {empqualificationlist?.map((item, ind) => (
                    <tr key={ind}>
                      <td>{item.institute_name}</td>
                      <td>{item.fromYear}</td>
                      <td>{item.toYear}</td>
                      <td>{item.degree_name}</td>
                      <td>{item.subjects}</td>
                      <td className="text-right">
                        <a
                          className="btn_7 small_btn mr05"
                          href={`${SERVER_URL}uploads/emp_degree/${item.doc}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="icon icon-eye"></i>
                        </a>
                        <button
                          className="btn_8 small_btn"
                          onClick={() => removeQualification(item.id)}
                        >
                          <i className="icon icon-cross"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div
                className="modal fade"
                id="educationdetail"
                tabIndex="-1"
                aria-labelledby="educationModalLabel"
                aria-modal="true"
                role="dialog"
              >
                <Modal show={qualificationmodal} size="md">
                  <div className="modal-body">
                    <div className="decorative-shape shape-1"></div>
                    <div className="decorative-shape shape-2"></div>
                    <button
                      type="button"
                      className="float-end btn_close"
                      onClick={handlequalificationClose}
                    >
                      <i className="icon icon-cross"></i>
                    </button>
                    <div
                      className="dash_white_box_ttl text-center"
                      id="educationModalLabel"
                    >
                      Add Qualification Detail
                    </div>
                    <div className="mb-2">
                      <label className="col-form-label">
                        Educational Institutions Name
                        <sup className="error_mgs">* {err_empInstitutions}</sup>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={empInstitutions}
                        onChange={(e) => setEmpInstitutions(e.target.value)}
                      />
                    </div>

                    <div className="row mb-2">
                      <div className="col-md-6">
                        <label className="col-form-label">
                          From Year{" "}
                          <sup className="error_mgs">
                            * {err_empInsfromdate}
                          </sup>
                        </label>
                        <DatePicker
                          showYearPicker
                          dateFormat="yyyy"
                          className="form-control"
                          minDate={new Date("1980", 0)}
                          maxDate={new Date("2020", 40)}
                          // value={empInsfromdate}
                          onChange={(date) => setEmpInsfromdate(date)}
                          selected={empInsfromdate}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          To Year{" "}
                          <sup className="error_mgs">* {err_empInstodate}</sup>
                        </label>
                        <DatePicker
                          className="form-control"
                          name="to_year"
                          showYearPicker
                          dateFormat="yyyy"
                          selected={empInstodate}
                          onChange={(date) => setEmpInstodate(date)}
                          minDate={new Date("1980", 0)}
                          maxDate={new Date("2020", 40)}
                        />
                      </div>
                    </div>
                    <div className="mb-2">
                      <label className="col-form-label">
                        Degree / Diploma Major Subjects{" "}
                        <sup className="error_mgs">* {err_empInstdegree}</sup>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="degree_name"
                        value={empInstdegree}
                        onChange={(e) => setEmpInstdegree(e.target.value)}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="col-form-label">
                        Major Subjects{" "}
                        <sup className="error_mgs">* {err_empInstsubject}</sup>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="subject"
                        value={empInstsubject}
                        onChange={(e) => setEmpInstsubject(e.target.value)}
                      />
                    </div>
                    <div className="mb-4">
                      <label className="col-form-label">
                        Upload Document{" "}
                        <sup className="error_mgs">* {err_insdocument}</sup>
                      </label>
                      <div className="form-input input-group">
                        <input
                          type="file"
                          name="degree_doc"
                          className="form-control uploadbtn"
                          id="degree_doc"
                          onChange={handleUploadDocument}
                        />
                      </div>
                      <span className="notice_text">
                        Allowed file: PDF, JPG, JPEG, PNG (Max size: 2MB)
                      </span>
                    </div>
                    <div className="modalfooter">
                      <button
                        type="button"
                        className="btn_6 float-end ml10"
                        onClick={handlequalificationClose}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn_5 float-end "
                        onClick={handleAddQualification}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </Modal>

                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-body">
                      <button
                        type="button"
                        className="float-end btn_close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <i className="icon icon-cross"></i>
                      </button>
                      <div
                        className="dash_white_box_ttl text-center"
                        id="educationModalLabel"
                      >
                        Add Qualification Detail
                      </div>
                      <div className="mb-2">
                        <label className="col-form-label">
                          Educational Institutions Name{" "}
                          <sup className="error_mgs">*</sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          defaultValue=""
                        />
                      </div>

                      <div className="row mb-2">
                        <div className="col-md-6">
                          <label className="col-form-label">
                            From Year <sup className="error_mgs">*</sup>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="from_year"
                            defaultValue=""
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="col-form-label">
                            To Year <sup className="error_mgs">*</sup>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="to_year"
                            defaultValue=""
                          />
                        </div>
                      </div>

                      <div className="mb-2">
                        <label className="col-form-label">
                          Degree / Diploma Major Subjects{" "}
                          <sup className="error_mgs">*</sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="degree_name"
                          defaultValue=""
                        />
                      </div>
                      <div className="mb-2">
                        <label className="col-form-label">
                          Major Subjects <sup className="error_mgs">*</sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="subject"
                          defaultValue=""
                        />
                      </div>
                      <div className="mb-4">
                        <label className="col-form-label">
                          Upload Document <sup className="error_mgs">*</sup>
                        </label>
                        <div className="form-input input-group">
                          <input
                            type="file"
                            name="degree_doc"
                            className="form-control uploadbtn"
                            id="degree_doc"
                          />
                        </div>
                      </div>
                      <div className="modalfooter">
                        <button
                          type="button"
                          className="btn_6 float-end ml10"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button type="button" className="btn_5 float-end ">
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Modal show={modal} size="md" id="confirm_login">
                <div className="modal-body">
                  <div className="decorative-shape shape-1"></div>
                  <div className="decorative-shape shape-2"></div>
                  <button
                    type="button"
                    className="float-end btn_close"
                    onClick={handleClose}
                  >
                    <i className="icon icon-cross fw-bold"></i>
                  </button>

                  <div
                    className="dash_white_box_ttl text-center"
                    id="exampleModalLabel"
                  >
                    Add Family Detail
                  </div>
                  <div className="mb-2">
                    <label className="col-form-label">
                      Name{" "}
                      <sup className="error_mgs">* {err_familymembername}</sup>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={familymembername}
                      onChange={(e) => setFamilymembername(e.target.value)}
                    />
                  </div>
                  <div className="mb-2">
                    <label className="col-form-label">
                      Relationship{" "}
                      <sup className="error_mgs">
                        * {err_familymemberrelation}
                      </sup>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="relationship"
                      value={familymemberrelation}
                      onChange={(e) => setFamilymemberrelation(e.target.value)}
                    />
                  </div>
                  <div className="mb-2 row">
                    <div className="col-md-6">
                      <label className="col-form-label">
                        Date of Birth{" "}
                        <sup className="error_mgs">* {err_familymemberdob}</sup>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="dob"
                        value={familymemberdob}
                        onChange={handleAge}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label">Age </label>
                      <input
                        type="text"
                        className="form-control"
                        readOnly
                        name="age"
                        value={familymemberage}
                      />
                    </div>
                  </div>
                  <div className="mb-4">
                    <label className="col-form-label">
                      Occupation{" "}
                      <sup className="error_mgs">
                        * {err_familymemberaccupation}
                      </sup>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="occupation"
                      value={familymemberaccupation}
                      onChange={(e) =>
                        setFamilymemberaccupation(e.target.value)
                      }
                    />
                  </div>
                  <div className="modalfooter">
                    <button
                      type="button"
                      className="btn_6 float-end ml10"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn_5 float-end"
                      onClick={saveFamilydetails}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </Modal>

              <div
                className="modal fade"
                id="addfamilydetail"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-modal="true"
                role="dialog"
              >
                {/* <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-body">
                      <button
                        type="button"
                        className="float-end btn_close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <i className="icon icon-cross"></i>
                      </button>
                      <div
                        className="dash_white_box_ttl text-center"
                        id="exampleModalLabel"
                      >
                        Add Family Detail
                      </div>
                      <div className="mb-2">
                        <label className="col-form-label">
                          Name{" "}
                          <sup className="error_mgs">
                            * {err_familymembername}
                          </sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={familymembername}
                          onChange={(e) => setFamilymembername(e.target.value)}
                        />
                      </div>
                      <div className="mb-2">
                        <label className="col-form-label">
                          Relationship{" "}
                          <sup className="error_mgs">
                            * {err_familymemberrelation}
                          </sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="relationship"
                          value={familymemberrelation}
                          onChange={(e) =>
                            setFamilymemberrelation(e.target.value)
                          }
                        />
                      </div>
                      <div className="mb-2 row">
                        <div className="col-md-6">
                          <label className="col-form-label">
                            Date of Birth{" "}
                            <sup className="error_mgs">
                              * {err_familymemberdob}
                            </sup>
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            name="dob"
                            value={familymemberdob}
                            onChange={handleAge}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="col-form-label">Age </label>
                          <input
                            type="text"
                            className="form-control"
                            readOnly
                            name="age"
                            value={familymemberage}
                          />
                        </div>
                      </div>
                      <div className="mb-4">
                        <label className="col-form-label">
                          Occupation{" "}
                          <sup className="error_mgs">
                            * {err_familymemberaccupation}
                          </sup>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="occupation"
                          value={familymemberaccupation}
                          onChange={(e) =>
                            setFamilymemberaccupation(e.target.value)
                          }
                        />
                      </div>
                      <div className="modalfooter">
                        <button
                          type="button"
                          className="btn_6 float-end ml10"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn_5 float-end"
                          onClick={saveFamilydetails}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="empprevious"
            role="tabpanel"
            aria-labelledby="empprevious-tab"
          >
            <div className="tab_content">
              <button
                className="btn_5 float-end minus_mt15"
                onClick={handlePreviousCompanyModal}
              >
                Add Previous Employment
              </button>
              <div className="tab_sub_ttl">Previous Employment Detail</div>
              <table className="monthly_table mt20 mb25">
                <thead>
                  <tr rowSpan="2">
                    <th>Company Name</th>
                    <th>Title of Position</th>
                    <th>Name &amp; Phone No. of Supervisor</th>
                    <th>From &amp; Till Date</th>
                    <th>Total CTC including Benefits</th>
                    <th>Address of Employer</th>
                    <th>Reason for Leaving</th>
                    <th className="text-right" style={{ width: "150px" }}>
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {empExp?.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No records added yet
                      </td>
                    </tr>
                  ) : (
                    empExp?.map((item, ind) => (
                      <tr key={ind}>
                        <td>{item.name}</td>
                        <td>{item.position}</td>
                        <td>
                          {item.nameOfSup} & {item.numberOfSup}
                        </td>
                        <td>
                          {item.fromdate} & {item.todate}
                        </td>
                        <td>{item.empctc}</td>
                        <td>{item.cmpadd}</td>
                        <td>{item.reasonleaving}</td>
                        <td className="text-right">
                          <a
                            className="small_btn btn_9 mr05"
                            href={`${SERVER_URL}uploads/previousCompantFiles/${item.appointment_letter}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            AL
                          </a>
                          <a
                            className="small_btn btn_7 mr05"
                            href={`${SERVER_URL}uploads/previousCompantFiles/${item.reliving_letter}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            RL
                          </a>
                          <button
                            className="btn_8 small_btn"
                            onClick={() =>
                              deleteEmpPreviousComp(item.id, item?.status_id)
                            }
                          >
                            <i className="icon icon-cross"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              <div className="joining_blk">
                <div className="tab_sub_ttl mb00">
                  Previous Company Salary Slip
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-blk">
                      <div className="form-label">
                        Slip 1 <sup className="error_mgs"> {err_empslip1}</sup>
                      </div>
                      <div className="form-input">
                        {(empslip1 == "" || empslip1 == null) && (
                          <>
                            <input
                              type="file"
                              name="salaryslipone"
                              className="form-control uploadbtn"
                              id="salaryslipone"
                              onChange={handleSalarySlipOne}
                              accept=".pdf, .jpg, .jpeg, .png"
                            />
                            <span className="notice_text">
                              Allowed file: PDF, JPG, JPEG, PNG (Max size: 2MB)
                            </span>
                          </>
                        )}
                        {empslip1 && (
                          <>
                            <a
                              className="btn_7 mr03"
                              href={`${SERVER_URL}uploads/slip/${empslip1}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="icon icon-eye mr03"></i> View File
                            </a>
                            <button
                              className="btn_8 small_btn"
                              onClick={() => deleteslip("slip1")}
                              title="Delete File"
                            >
                              <i class="icon icon-cross"></i>
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk">
                      <div className="form-label">
                        Slip 2 <sup className="error_mgs"> {err_empslip2}</sup>
                      </div>
                      <div className="form-input">
                        {(empslip2 == "" || empslip2 == null) && (
                          <>
                            <input
                              type="file"
                              name="salarysliptwo"
                              className="form-control uploadbtn"
                              id="salarysliptwo"
                              onChange={handleSalarySlipTwo}
                            />
                            <span className="notice_text">
                              Allowed file: PDF, JPG, JPEG, PNG (Max size: 2MB)
                            </span>
                          </>
                        )}
                        {empslip2 && (
                          <>
                            <a
                              className="btn_7 mr03"
                              href={`${SERVER_URL}uploads/slip/${empslip2}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="icon icon-eye mr03"></i> View File
                            </a>
                            <button
                              className="btn_8 small_btn"
                              onClick={() => deleteslip("slip2")}
                              title="Delete File"
                            >
                              <i class="icon icon-cross"></i>
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk">
                      <div className="form-label">
                        Slip 3 <sup className="error_mgs"> {err_empslip3}</sup>
                      </div>
                      <div className="form-input">
                        {(empslip3 == "" || empslip3 == null) && (
                          <>
                            <input
                              type="file"
                              name="salaryslipthree"
                              className="form-control uploadbtn"
                              id="salaryslipthree"
                              onChange={handleSalarySlipThree}
                            />
                            <span className="notice_text">
                              Allowed file: PDF, JPG, JPEG, PNG (Max size: 2MB)
                            </span>
                          </>
                        )}
                        {empslip3 && (
                          <>
                            <a
                              className="btn_7 mr03"
                              href={`${SERVER_URL}uploads/slip/${empslip3}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="icon icon-eye mr03"></i> View File
                            </a>
                            <button
                              className="btn_8 small_btn"
                              onClick={() => deleteslip("slip3")}
                              title="Delete File"
                            >
                              <i class="icon icon-cross"></i>
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Modal show={previousCompanymodal} size="lg">
                <div className="modal-body">
                  <button
                    type="button"
                    className="float-end btn_close"
                    onClick={handlePreviousCompanyModalClose}
                  >
                    <i className="icon icon-cross"></i>
                  </button>
                  <div
                    className="dash_white_box_ttl text-center mb10"
                    id="previousModalLabel"
                  >
                    Add Previous Employment Detail
                  </div>
                  <div className="row mb10">
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">
                          Company Name
                          <sup className="error_mgs "> *{err_company}</sup>
                        </div>
                        <div className="form-input">
                          <input
                            value={comname}
                            onChange={(e) => setComname(e.target.value)}
                            type="text"
                            name="company_name"
                            id="company_name"
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">
                          Title of Position
                          <sup className="error_mgs "> *{err_position}</sup>
                        </div>
                        <div className="form-input">
                          <input
                            type="text"
                            name="position"
                            id="position"
                            className="form-control form-control1"
                            onChange={(e) => setTitleOfpostion(e.target.value)}
                            value={titleOfposition}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">
                          Name of Supervisor
                          <sup className="error_mgs "> *{err_supervisor}</sup>
                        </div>
                        <div className="form-input">
                          <input
                            type="text"
                            name="supervisor"
                            id="supervisor"
                            className="form-control form-control1"
                            onChange={(e) =>
                              setNameOfsupervisor(e.target.value)
                            }
                            value={nameOfsupervisor}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">
                          Phone Number of Supervisor
                          <sup className="error_mgs ">
                            *{err_supervisor_number}
                          </sup>
                        </div>
                        <div className="form-input">
                          <input
                            type="text"
                            name="supervisor_mobno"
                            id="supervisor_mobno"
                            className="form-control form-control1"
                            value={numberOfsupervisor}
                            onChange={(e) => {
                              const onlyNums = e.target.value.replace(
                                /\D/g,
                                "",
                              );
                              setNumberOfsupervisor(onlyNums);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-blk mb15">
                        <div className="col-form-label">
                          From Date
                          <sup className="error_mgs ">*{err_empfromdate}</sup>
                        </div>
                        <div className="form-input">
                          <input
                            type="date"
                            name="from_date"
                            id="from_date"
                            className="form-control form-control1"
                            value={empFromDate}
                            onChange={(e) => setEmpFromDate(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-blk mb15">
                        <div className="col-form-label">
                          To Date
                          <sup className="error_mgs ">*{err_emptodate}</sup>
                        </div>
                        <div className="form-input">
                          <input
                            type="date"
                            name="to_date"
                            id="to_date"
                            className="form-control form-control1"
                            value={empToDate}
                            onChange={(e) => setEmpToDate(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">
                          Total CTC including Benefits
                          <sup className="error_mgs ">*{err_empctc}</sup>
                        </div>
                        <div className="form-input">
                          <input
                            type="text"
                            name="total_pre_ctc"
                            id="total_pre_ctc"
                            className="form-control form-control1"
                            value={empctc}
                            onChange={(e) => {
                              const ctcNum = e.target.value.replace(/\D/g, "");
                              setEmpctc(ctcNum);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">
                          Address of Employer
                          <sup className="error_mgs ">*{err_cmpadd}</sup>
                        </div>
                        <div className="form-input">
                          <input
                            value={cmpadd}
                            onChange={(e) => setCmpadd(e.target.value)}
                            type="text"
                            name="address_employer"
                            id="address_employer"
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">Reason for Leaving</div>
                        <div className="form-input">
                          <input
                            value={reasonLeaving}
                            onChange={(e) => setReasonLeaving(e.target.value)}
                            type="text"
                            name="reason_leaving"
                            id="reason_leaving"
                            className="form-control form-control1"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">
                          Upload Reliving Letter
                          <sup className="error_mgs ">
                            *{err_releavingfile}
                            {err_uploadedRelivingLetter}
                          </sup>
                        </div>
                        <div className="form-input input-group">
                          <>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handleReleavingLetterUpload}
                              ref={relavingLetterRef}
                              className="form-control uploadbtn"
                              id="reliving_letter"
                            />
                          </>
                        </div>
                        <span className="notice_text">
                          Allowed file: PDF, JPG, JPEG, PNG (Max size: 2MB)
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-blk mb15">
                        <div className="col-form-label">
                          Upload Appointment Letter
                          <sup className="error_mgs ">
                            *{err_appointmentfile}
                            {err_uploadedUppointmentLetter}
                          </sup>
                        </div>
                        <div className="form-input input-group">
                          <>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handleAppointmentLetterUpload}
                              ref={appointmentLetterRef}
                              name="appointment_letter"
                              className="form-control uploadbtn"
                              id="appointment_letter"
                            />
                          </>
                        </div>
                        <span className="notice_text">
                          Allowed file: PDF, JPG, JPEG, PNG (Max size: 2MB)
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="modalfooter">
                    <button
                      type="button"
                      className="btn_6 float-end ml10"
                      onClick={handlePreviousCompanyModalClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={addRecord}
                      className="btn_5 float-end "
                    >
                      Add
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="skillset"
            role="tabpanel"
            aria-labelledby="skill-tab"
          >
            <div className="tab_content">
              <div className="tab_sub_ttl">Skills</div>
              <Skills
                department={department}
                userSkillParentCallback={userSkillParentCallback}
                page_action={"edit"}
                department_id={department}
              />
            </div>
          </div>
          <div className="tab_footer text-end">
            <span className="mr08" style={{ color: color ? color : "" }}>
              {errmsg}
            </span>
            <button
              onClick={handleEdituser}
              className="btn_5"
              style={{ display: buttonstatus == true ? "" : "none" }}
            >
              Save
            </button>
            <Link to="/employeelist" className="btn_6 ml10">
              Cancel
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditEmployeeCom;
